<template>
  <div>
    <LanguageSelector />
    <div v-if="!editingHouse">
      <Alert
        v-if="error == 'error-message'"
        :text="errorText"
        type="danger"
        dismissable="false"
      />
      <!-- House Banner -->
      <h2 class="mb-2">{{ house.name }}</h2>
      <!-- House Actions -->
      <div style="float: left" v-if="!editingHouse">
        <span v-if="!reject">
          <button
            class="btn btn-secondary"
            v-if="house.status == 'draft_by_admin'"
            @click="startEditProperty()"
          >{{$t('Continue')}}</button>
          <button
            class="btn btn-secondary"
            v-if="house.status == 'draft_by_landlord' || house.status == 'needs_approval_by_admin' || house.status == 'preapproved' || house.status == 'needs_approval_by_landlord' || house.status == 'rejected_by_admin' || house.status == 'rejected_by_landlord'"
            @click="startEditProperty()"
          >{{$t('Edit')}}</button>
          <button
            class="btn btn-success"
            @click="approveProperty()"
            v-if="house.status == 'needs_approval_by_admin' || house.status == 'rejected_by_admin'"
          >{{$t('Approve')}}</button>
          <button
            class="btn btn-danger"
            @click="rejectPropertyModal()"
            v-if="house.status == 'needs_approval_by_admin'"
          >{{$t('Reject')}}</button>
          <button class="btn btn-danger" @click="deleteProperty()" v-if="canDelete()">{{$t('Delete')}}</button>
          <button
            class="btn btn-secondary"
            v-if="house.status == 'approved'"
            @click="createProposal(house.uid)"
          >{{$t('Create Proposal')}}</button>
        </span>
        <span v-else>
          <button class="btn btn-secondary" @click="goBack()">{{$t('Go Back to Actions')}}</button>
          <button class="btn btn-danger" @click="rejectProperty()">{{$t('Reject Property')}}</button>
          <input
            type="text"
            class="form-control mt-1"
            :placeholder="$t('Reject reason...')"
            v-model="rejectReason"
          />
          <small class="text-danger" v-if="errorReject">
            {{$t('Please insert a')}}
            <strong>{{$t('reject reason')}}</strong>.
          </small>
        </span>
      </div>
      <div style="float: left" v-else>
        <button class="btn btn-secondary" @click="goBack()">{{$t('Go Back to Actions')}}</button>
      </div>

      <br /><br /><br />
      <small v-if="house.createdAt">Created on {{ house.createdAt.split("T")[0] }}</small>
      <br />
      <div
        class="badge badge-warning mr-1 mb-1 mt-1"
        v-if="house.status == 'preapproved'"
      >{{ house.status.replaceAll("_", " ").toUpperCase() }}</div>
      <div
        class="badge badge-secondary mr-1 mb-1 mt-1"
        v-if="house.status == 'draft_by_admin'"
      >{{ house.status.replaceAll("_", " ").toUpperCase() }}</div>
      <div
        class="badge badge-secondary mr-1 mb-1 mt-1"
        v-if="house.status == 'draft_by_landlord'"
      >{{ house.status.replaceAll("_", " ").toUpperCase() }}</div>
      <div
        class="badge badge-info mr-1 mb-1 mt-1"
        v-if="house.status == 'needs_approval_by_admin'"
      >{{ house.status.replaceAll("_", " ").toUpperCase() }}</div>
      <div
        class="badge badge-info mr-1 mb-1 mt-1"
        v-if="house.status == 'needs_approval_by_landlord'"
      >{{ house.status.replaceAll("_", " ").toUpperCase() }}</div>
      <div
        class="badge badge-success mr-1 mb-1 mt-1"
        v-if="house.status == 'approved'"
      >{{ house.status.replaceAll("_", " ").toUpperCase() }}</div>
      <div
        class="badge badge-danger mr-1 mb-1 mt-1"
        v-if="house.status == 'rejected_by_admin'"
      >{{ house.status.replaceAll("_", " ").toUpperCase() }}</div>
      <div
        class="badge badge-danger mr-1 mb-1 mt-1"
        v-if="house.status == 'rejected_by_landlord'"
      >{{ house.status.replaceAll("_", " ").toUpperCase() }}</div>

      <br />
      <div class="row" v-if="house.statusDescription">
        <div class="col-6">
          <label for>{{$t('Status Description')}}</label>
          <textarea
            cols="30"
            rows="7"
            class="form-control"
            disabled
            :value="house.statusDescription"
          ></textarea>
        </div>
      </div>

      <!-- Owner Informations -->
      <h4 class="mt-2">{{$t('Owner Information')}}</h4>
      <p class="mt-1" v-if="house.country" style="line-height: 30px;">
        <span v-if="house.owner.user">
          <strong>{{$t('Name')}}:</strong>
          <span v-if="house.owner.user.name">{{ house.owner.user.name }}</span>
          <br>
          <span v-if="house.owner.user.email">
            <strong>{{$t('Email')}}:</strong> {{ house.owner.user.email }}
          </span>
          <br>
          <span v-if="house.owner.user.phoneNumber">
            <strong>{{$t('Phone Number')}}:</strong> {{ house.owner.user.phoneNumber }}
          </span>
        </span>


        <span v-if="house.owner.invite">
          <strong>{{$t('Name')}}:</strong>
          <span v-if="house.owner.invite.name">{{ house.owner.invite.name }}</span>
          <br>
          <span v-if="house.owner.invite.email">
            <strong>{{$t('Email')}}:</strong> {{ house.owner.invite.email }}
          </span>
          <br>
          <span v-if="house.owner.invite.phoneNumber">
            <strong>{{$t('Phone Number')}}:</strong> {{ house.owner.invite.phoneNumber }}
          </span>
        </span>
        <br>


        <strong>{{$t('Language')}}:</strong>
        <span v-if="house.owner.user">
          <span v-if="house.owner.user">{{ (house.owner.user.language === 'en') ? 'English' : 'Arabic' }}</span>
        </span>
        <span v-if="house.owner.invite">
          <span v-if="house.owner.invite">{{ house.owner.invite.language }}</span>
        </span>
        <br>
        <strong>{{$t('Country')}}:</strong> {{ countryName(house.country) }}
        <br>
        <span v-if="house.owner.user">
          <small class="text-muted d-block">
            <router-link :to="{name: 'SingleUserPage', params: {uuid: house.owner.user.uid} }">{{$t('View Details')}}</router-link>
          </small>
        </span>
      </p>

      <!-- House Informations -->
      <h4 class="mt-2">{{$t('Property Information')}}</h4>
      <div class="row">
        <div class="col-6">
          <div v-if="house.address && house.country">
            <small>{{$t('Address')}}:</small>
            <p style="margin-top: 7px;">
              <span v-if="house.address.street">{{ house.address.street }},</span>
              <br>
              <span v-if="house.address.city">{{ house.address.city }},</span> {{ house.country.toUpperCase() }}
              <br>
              <span v-if="house.address.zip">{{ house.address.zip }}</span>
              <br>
              <span v-if="house.address.additional">{{ house.address.additional }}</span>
            </p>

            <small>{{$t('Building Informations')}}:</small>
            <p style="margin-top: 7px;">
              {{ house.address.buildingName }}
              <br />
              {{ house.address.registryNumber }}
            </p>
          </div>
        </div>
        <div class="col-6">
          <div v-if="house.details">
            <small>{{$t('House info')}}</small>

            <p style="margin-top: 7px;">{{ house.details.floor }} {{$t('floor')}}, {{ house.details.size }}mq</p>
          </div>

          <div v-if="house.details">
            <small>{{$t('Rooms and Spaces')}}</small>

            <p style="margin-top: 7px;">
              {{ house.details.bedrooms }} {{$t('Bedrooms')}}, {{ house.details.livingrooms }} {{$t('Living rooms')}}, {{ house.details.bathrooms }} {{$t('Bathrooms')}}
              <br />
              {{ house.details.kitchens }} {{$t('Kitchens')}}
            </p>
          </div>

          <small>{{$t('Amenities and other accessories')}}</small>

          <div v-if="house.info && house.info.utilities">
            <p style="margin-top: 7px; margin-bottom: 0px;" v-for="(utility, index) in house.info.utilities" :key="index">
              {{ utility.name }} - <span class="capitalize">{{ utility.paymentType.replaceAll("_", " ") }}<span v-if="utility.amount">, {{ utility.amount }}<span v-if="utility.paymentType != 'shared_percentage'"> LBP</span><span v-else>% {{$t('Tenant')}}</span></span><span v-if="utility.recurrence">/{{ utility.recurrence }}</span></span>
            </p>
          </div>

          <div v-if="house.info && house.info.inventory">
            <hr>
            <strong>{{$t('Inventory')}}</strong>
            <p style="margin-top: 7px; margin-bottom: 0px;" v-for="(element, index) in house.info.inventory" :key="index">
              {{ element }}
            </p>
          </div>
        </div>
      </div>

      <!-- House Photos -->
      <div id="images-wrapper" v-if="house.photos" class="mt-3">
        <small>{{$t('House Photos')}} ({{ house.photos.length }} {{$t('photos')}})</small>
        <div class="row mt-1">
          <div class="col-md-2" v-for="(image, index) in house.photos" :key="index">
            <div class="house-image house-zoom" @click="zoomImage(image)">
              <img :src="image" class="img-fluid rounded" alt="house img"/>
            </div>
          </div>
        </div>
      </div>

      <!-- Rent Requests -->
      <div v-if="rent.length">
        <h4 class="mt-4">{{$t('Contract Proposals')}}</h4>
        <proposals-table-component v-if="rent" :proposals='rent'></proposals-table-component>
      </div>

      <div v-if="contractsData.length">
        <h4 class="mt-4">{{$t('Contracts')}}</h4>
        <contracts-table-component v-if="rent" :contracts='contractsData'></contracts-table-component>
      </div>
      <!-- <div class="row mt-1">
        <div class="col-md-4">
          <p style="line-height: 25px;">
            Start date: <strong>{{ rent.start }}</strong>
            <br />End date: <strong>{{ rent.end }}</strong>
          </p>
        </div>
        <div class="col-md-4">
          <p style="line-height: 25px;">
            Monthly rent:
            <strong>{{ house.askingMonthlyRent }} {{ house.currency }}</strong>
            <br />Deposit:
            <strong>{{ house.askingDeposit }} {{ house.currency }}</strong>
            <br />Months to pay in advance:
            <strong>{{ house.askingAdvanceMonths }}</strong>
          </p>
        </div>
      </div> -->
    </div>

    <!-- Editing House -->
    <div v-else>

      <!-- Scrollable Screen -->
      <div class="scrollable-screen hidden">
        <div class="container-fluid">
            <div class="row justify-content-center">
              <div class="col-md-9 col-sm-12 mb-1">
                <Alert :text="$t('Any edit will restart the process')" type="warning" v-if="negotiationInProcess"/>
                <button class="btn btn-secondary" @click="goBack()">{{$t('Go Back to Actions')}}</button>
              </div>
              <div class="col-12" :class="(house && house.status != 'draft_by_admin') ? 'col-md-9' : 'col-md-5'">
                <div>
                  <label for>{{$t('House Name')}}</label>
                  <input type="text" class="form-control" v-model="houseName" />
                </div>
              </div>
              <div class="col-md-4 col-12" v-if="house && house.status == 'draft_by_admin'">
                <div>
                  <label for>{{$t('Status')}}</label>
                  <select class="form-control capitalize" v-model="houseStatus">
                    <option value="draft_by_admin" v-if="house && house.status == 'draft_by_admin'">{{$t('Draft by Admin')}}</option>
                    <option value="needs_approval_by_landlord" v-if="house && house.status == 'draft_by_admin'">{{$t('Needs Approval by Landlord')}}</option>
                  </select>
                </div>
              </div>
            </div>


            <div class="row mt-2 justify-content-center">
              <div class="col-md-2 col-12">
                <div>
                  <label for>{{$t('Country')}}</label>
                  <select class="form-control" v-model="houseCountry">
                    <option
                      v-for="(aC, index) in activeCountries"
                      :key="index"
                      :value="aC.toLowerCase()"
                    >{{ countryName(aC) }}</option>
                  </select>
                </div>
              </div>
              <div class="col-md-3 col-12">
                <div>
                  <label for>{{$t('City')}}</label>
                  <input type="text" class="form-control" v-model="houseCity" />
                </div>
              </div>
              <div class="col-md-3 col-12">
                <div>
                  <label for>{{$t('Street')}}</label>
                  <input type="text" class="form-control" v-model="houseStreet" />
                </div>
              </div>
              <div class="col-md-1 col-sm-12">
                <label for>{{$t('ZIP')}}</label>
                <input type="text" class="form-control" v-model="houseZip" />
              </div>
            </div>

            <div class="row mt-2 justify-content-center">
              <div class="col-md-9 col-sm-12">
                <div class="text-right">
                  <button class="btn btn-primary" type="button" @click="editHouse()">{{$t('Save Changes')}}</button>
                </div>
              </div>
            </div>
        </div>
      </div>

      <div>
        <div class="text-left mb-2">
          <Alert text="Any edit <strong>will restart</strong> the negotiation process" type="warning" v-if="negotiationInProcess"/>
          <Alert
            v-if="error == 'error-message'"
            :text="errorText"
            type="danger"
            dismissable="false"
          />
          <button class="btn btn-secondary" @click="goBack()">{{$t('Go Back to Actions')}}</button>
        </div>
      </div>

      <div>
        <form class="form">
          <div class="form-body">
            <div class="row">
              <div class="col-md-5 col-12">
                <div>
                  <label for>{{$t('House Name')}}</label>
                  <input type="text" class="form-control" v-model="houseName" />
                </div>
              </div>
              <div class="col-md-4 col-12" v-if="house && house.status == 'draft_by_admin'">
                <div>
                  <label for>{{$t('Status')}}</label>
                  <select class="form-control capitalize" v-model="houseStatus">
                    <option value="draft_by_admin" v-if="house && house.status == 'draft_by_admin'">{{$t('Draft by Admin')}}</option>
                    <option value="needs_approval_by_landlord" v-if="house && house.status == 'draft_by_admin'">{{$t('Needs Approval by Landlord')}}</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-md-2 col-12">
                <div>
                  <label for>{{$t('Country')}}</label>
                  <select class="form-control" v-model="houseCountry">
                    <option
                      v-for="(aC, index) in activeCountries"
                      :key="index"
                      :value="aC.toLowerCase()"
                    >{{ countryName(aC) }}</option>
                  </select>
                </div>
              </div>
              <div class="col-md-3 col-12">
                <div>
                  <label for>{{$t('City')}}</label>
                  <input type="text" class="form-control" v-model="houseCity" />
                </div>
              </div>
              <div class="col-md-3 col-12">
                <div>
                  <label for>{{$t('Street')}}</label>
                  <input type="text" class="form-control" v-model="houseStreet" />
                </div>
              </div>
              <div class="col-md-1 col-sm-12">
                <label for>{{$t('ZIP')}}</label>
                <input type="text" class="form-control" v-model="houseZip" />
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-md-3 col-12">
                <div>
                  <label for>Building Name</label>
                  <input type="text" class="form-control" v-model="houseBuildingName" />
                </div>
              </div>
              <div class="col-md-3 col-12">
                <div>
                  <label for>{{$t('Registry Number')}}</label>
                  <input type="text" class="form-control" v-model="houseRegistryNumber" />
                </div>
              </div>
              <div class="col-md-3 col-12">
                <div>
                  <label for>{{$t('Apt/Unit')}}</label>
                  <input type="text" class="form-control" v-model="houseAdditional" />
                </div>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-md-9 col-sm-12">
                <label for>{{$t('Description of Location/How to find')}}</label>
                <textarea cols="30" rows="3" class="form-control" v-model="houseDescription"></textarea>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-md-3 col-sm-12">
                <label for>{{$t('Available Date')}}</label>
                <div class="form-group position-relative has-icon-left">
                  <input
                    type="text"
                    class="form-control"
                    :placeholder="$t('Select Date')"
                    id="date-input"
                    v-model="availableDate"
                  />
                  <div class="form-control-position">
                    <em class="bx bx-calendar"></em>
                  </div>
                </div>
              </div>
              <div class="col-md-3 col-sm-12">
                <label for>{{$t('Asking Rent')}}</label>
                <input
                  type="number"
                  step="1.00"
                  min="0"
                  class="form-control"
                  v-model="askingRent"
                />
              </div>
              <div class="col-md-3 col-sm-12">
                <label for>{{$t('Currency')}}</label>
                <select class="form-control" v-model="currency">
                  <option value selected disabled>{{$t('Choose Currency...')}}</option>
                  <option value="LBP">{{$t('LBP')}}</option>
                  <option value="JOD">{{$t('JOD')}}</option>
                  <option value="PLN">{{ $t("PLN") }}</option>
                  <option value="UAH">{{ $t("UAH") }}</option>
                  <option value="USD">{{ $t("USD") }}</option>
                  <option value="CAD">{{ $t("CAD") }}</option>
                  <option value="PEN">{{ $t("PEN") }}</option>
                  <option value="COP">{{ $t("COP") }}</option>
                  <option value="EUR">{{ $t("EUR") }}</option>
                </select>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-md-3 col-sm-12">
                <label for>{{$t('Asking Deposit')}}</label>
                <input
                  type="number"
                  step="1.00"
                  min="0"
                  class="form-control"
                  v-model="askingDeposit"
                />
              </div>
              <div class="col-md-3 col-sm-12">
                <label for>{{$t('Asking Advance Payments (In months)')}}</label>
                <input
                  type="number"
                  step="1"
                  min="0"
                  class="form-control"
                  v-model="askingAdvanceMonths"
                />
              </div>
              <div class="col-md-3 col-sm-12">
                <label for>{{$t('House Type')}}</label>
                <select class="form-control" v-model="houseType">
                  <option value="apartment">{{$t('Apartment')}}</option>
                  <option value="secondary unit">{{$t('Secondary Unit')}}</option>
                  <option value="one family detached">{{$t('One Family Detached')}}</option>
                  <option value="multi-family apartment">{{$t('Multi-Family Apartment')}}</option>
                </select>
                <!-- <input type="text" class="form-control" v-model="houseType" /> -->
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-md-3 col-sm-12">
                <label for>{{$t('House Size')}}</label>
                <input
                  type="number"
                  step="1"
                  min="0"
                  class="form-control"
                  v-model="houseSize"
                />
              </div>
              <div class="col-md-3 col-sm-12">
                <label for>{{$t('Max Tenants')}}</label>
                <input
                  type="number"
                  step="1"
                  min="0"
                  class="form-control"
                  v-model="maxTenants"
                />
              </div>
              <div class="col-md-3 col-sm-12">
                <label for>{{$t('Floor')}}</label>
                <input
                  type="number"
                  step="1"
                  min="0"
                  class="form-control"
                  v-model="floor"
                />
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-md-3 col-sm-12">
                <label for>{{$t('Kitchens')}}</label>
                <input
                  type="number"
                  step="1"
                  min="0"
                  class="form-control"
                  v-model="kitchens"
                />
                <div style="margin-top: 10px;">
                  <div class="checkbox checkbox-primary checkbox-glow">
                    <input type="checkbox" id="shared-kitchen" :checked="sharedKitchen" />
                    <label for="shared-kitchen">{{$t('Shared')}}</label>
                  </div>
                </div>
              </div>
              <div class="col-md-3 col-sm-12">
                <label for>{{$t('Living Rooms')}}</label>
                <input
                  type="number"
                  step="1"
                  min="0"
                  class="form-control"
                  v-model="livingRooms"
                />
              </div>
              <div class="col-md-3 col-sm-12">
                <label for>{{$t('Bedrooms')}}</label>
                <input
                  type="number"
                  step="1"
                  min="0"
                  class="form-control"
                  v-model="bedrooms"
                />
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-md-3 col-sm-12">
                <label for>{{$t('Bathrooms')}}</label>
                <input
                  type="number"
                  step="1"
                  min="0"
                  class="form-control"
                  v-model="bathrooms"
                />
                <div style="margin-top: 10px;">
                  <div class="checkbox checkbox-primary checkbox-glow">
                    <input type="checkbox" id="shared-bathroom" :checked="sharedBathrooms" />
                    <label for="shared-bathroom">{{$t('Shared')}}</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-md-9 col-sm-12">
                <label for>{{$t('Condition Description')}}</label>
                <textarea cols="30" rows="5" class="form-control" :placeholder="$t('Description...')" v-model="conditionDescription"></textarea>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-md-9 col-sm-12">
                <label for>{{$t('Known Defects/Issues')}}</label>
                <textarea cols="30" rows="5" class="form-control" :placeholder="$t('Write here any defect or issue')" v-model="defects"></textarea>
              </div>
            </div>

            <!-- House Photos -->
            <div id="images-wrapper" v-if="house.photos" class="mt-2">
              <small>{{$t('House Photos')}} ({{ house.photos.length }} {{$t('photos')}})</small>
              <div class="row mt-1">
                <div class="col-md-2" v-for="(image, index) in house.photos" :key="index">
                  <div class="house-image">
                    <div class="overlay text-white">
                      <em class="bx bx-trash" @click="deleteImage(index)"></em>
                    </div>
                    <img :src="image" class="img-fluid rounded" alt="House img" />
                  </div>
                </div>
              </div>
            </div>

            <span class="btn btn-primary mt-3" @click="$refs.file.click()">
              <input
                type="file"
                ref="file"
                @change="uploadImage($event)"
                accept="image/*"
                style="display: none;"
              />
              {{$t('Upload new photo')}}
            </span>

            <div class="text-right" style="margin-top: -35px;">
              <span class="btn btn-danger" v-if="image" @click="image = null">
                {{$t('Delete Image')}}
              </span>

              <span class="btn btn-success" v-if="image" @click="storeImage()">
                {{$t('Save Image')}}
              </span>
            </div>

            <div class="text-left my-3">
              <cropper :src="image" ref="cropper"/>
            </div>

            <div class="row" style="margin-top: 80px;">
              <div class="col-md-6 col-sm-12">
                <h4>{{$t('Services & Utilities')}}</h4>

                <div style="margin-top: 13px;" class="mt-1">
                  <div class="checkbox checkbox-primary checkbox-glow">
                    <input
                      class="service-checkbox"
                      value="Electricity costs"
                      type="checkbox"
                      id="electricity-cost"
                      :checked="houseUtilitiesSelected.includes('Electricity costs')"
                      @change="handleServiceCheckbox($event, 'Electricity costs')"
                    />
                    <label for="electricity-cost">{{$t('Electricity costs')}}</label>
                  </div>
                </div>

                <div v-if="electricityDetails">
                  <hr style="width: 320px; margin-left: 0;" />
                  <small>{{$t('Who will be in change of this bill?')}}</small>
                  <ul class="list-unstyled mb-0 mt-1">
                    <li class="mr-2 mb-1">
                      <div>
                        <div class="radio">
                          <input
                            class="electricity-radio"
                            value="tenant"
                            type="radio"
                            name="bsradio"
                            id="radio1"
                            @change="handleSharedRadio($event, 'tenant', 'Electricity costs')"
                            :checked="houseUtilitiesComplete[houseUtilitiesSelected.indexOf('Electricity costs')] && houseUtilitiesComplete[houseUtilitiesSelected.indexOf('Electricity costs')].paymentType == 'tenant'"
                          />
                          <label for="radio1">{{$t('Tenant')}}</label>
                        </div>
                      </div>
                    </li>
                    <li class="mr-2 mb-1">
                      <div>
                        <div class="radio">
                          <input
                            class="electricity-radio"
                            value="owner"
                            type="radio"
                            name="bsradio"
                            id="radio2"
                            @change="handleSharedRadio($event, 'owner', 'Electricity costs')"
                            :checked="houseUtilitiesComplete[houseUtilitiesSelected.indexOf('Electricity costs')] && houseUtilitiesComplete[houseUtilitiesSelected.indexOf('Electricity costs')].paymentType == 'owner'"
                          />
                          <label for="radio2">{{$t('Property Owner')}}</label>
                        </div>
                      </div>
                    </li>
                    <li class="mr-2 mb-1">
                      <div>
                        <div class="radio">
                          <input
                            class="electricity-radio"
                            value="fixed_amount"
                            type="radio"
                            name="bsradio"
                            id="radio3"
                            @change="handleSharedRadio($event, 'tenant_fixed', 'Electricity costs')"
                            :checked="houseUtilitiesComplete[houseUtilitiesSelected.indexOf('Electricity costs')] && houseUtilitiesComplete[houseUtilitiesSelected.indexOf('Electricity costs')].paymentType == 'fixed_amount'"
                          />
                          <label for="radio3">{{$t('Tenant’s fixed amount')}}</label>
                        </div>
                      </div>
                      <div
                        class="row"
                        style="width: 350px; margin-top: 20px;"
                        v-if="electricityFixed"
                      >
                        <div class="col">
                          <input
                            type="number"
                            step="1"
                            min="0"
                            class="form-control"
                            :placeholder="$t('currency')"
                            v-model="electricityFixedAmount"
                          />
                        </div>
                        <div class="col">
                          <select class="form-control" v-model="electricityFixedAmountRecurrence">
                            <option value="monthly">{{$t('Monthly')}}</option>
                            <option value="bi-monthly">{{$t('Bi-Monthly')}}</option>
                            <option value="yearly">{{$t('Yearly')}}</option>
                          </select>
                        </div>
                      </div>
                    </li>
                    <li class="mr-2 mb-1">
                      <div>
                        <div class="radio">
                          <input
                            type="radio"
                            class="electricity-radio"
                            value="shared_usage"
                            name="bsradio"
                            id="radio4"
                            @change="handleSharedRadio($event, 'shared', 'Electricity costs')"
                            :checked="houseUtilitiesComplete[houseUtilitiesSelected.indexOf('Electricity costs')] && houseUtilitiesComplete[houseUtilitiesSelected.indexOf('Electricity costs')].paymentType == 'shared_usage'"
                          />
                          <label for="radio4">{{$t('Shared (Tenant’s usage)')}}</label>
                        </div>
                      </div>
                    </li>
                    <li class="mr-2 mb-1">
                      <div>
                        <div class="radio">
                          <input
                            class="electricity-radio"
                            value="shared_percentage"
                            type="radio"
                            name="bsradio"
                            id="radio5"
                            @change="handleSharedRadio($event, 'fixed_percentage', 'Electricity costs')"
                            :checked="houseUtilitiesComplete[houseUtilitiesSelected.indexOf('Electricity costs')] && houseUtilitiesComplete[houseUtilitiesSelected.indexOf('Electricity costs')].paymentType == 'shared_percentage'"
                          />
                          <label for="radio5">{{$t('Shared (Fixed percentage)')}}</label>
                        </div>
                      </div>
                      <div
                        style="display: flex; margin-top: 20px; width: 320px;"
                        v-if="electricityShared"
                      >
                        <p style="float: left; padding-right: 10px;">
                          <strong>{{$t('Tenant')}}</strong>
                          <br />
                          <small>{{ (electricityPercentage <= 50) ? electricityPercentage : 100 - electricityPercentage }}%</small>
                        </p>
                        <input
                          type="range"
                          class="custom-range"
                          id="customRange1"
                          v-model="electricityPercentage"
                        />
                        <p style="float: right; padding-left: 10px;">
                          <strong>{{$t('Landlord')}}</strong>
                          <br />
                          <small>{{ (electricityPercentage <= 50) ? 100 - electricityPercentage : electricityPercentage }}%</small>
                        </p>
                      </div>
                    </li>
                  </ul>
                  <button
                    class="btn btn-primary"
                    style="width: 320px"
                    type="button"
                    @click="addNewUtility('Electricity costs')"
                  >{{$t('Confirm')}}</button>
                  <hr style="width: 320px; margin-left: 0;" />
                </div>

                <div style="margin-top: 13px;">
                  <div class="checkbox checkbox-primary checkbox-glow">
                    <input
                      class="service-checkbox"
                      value="Phone bills"
                      type="checkbox"
                      id="phone-bills"
                      :checked="houseUtilitiesSelected.includes('Phone bills')"
                      @change="handleServiceCheckbox($event, 'Phone bills')"
                    />
                    <label for="phone-bills">{{$t('Phone bills')}}</label>
                  </div>
                </div>

                <div v-if="phoneDetails">
                  <hr style="width: 320px; margin-left: 0;" />
                  <small>{{$t('Who will be in change of this bill?')}}</small>
                  <ul class="list-unstyled mb-0 mt-1">
                    <li class="mr-2 mb-1">
                      <div>
                        <div class="radio">
                          <input
                            class="phone-radio"
                            value="tenant"
                            type="radio"
                            name="bsradio2"
                            id="radio6"
                            @change="handleSharedRadio($event, 'tenant', 'Phone bills')"
                            :checked="houseUtilitiesComplete[houseUtilitiesSelected.indexOf('Phone bills')] && houseUtilitiesComplete[houseUtilitiesSelected.indexOf('Phone bills')].paymentType == 'tenant'"
                          />
                          <label for="radio6">{{$t('Tenant')}}</label>
                        </div>
                      </div>
                    </li>
                    <li class="mr-2 mb-1">
                      <div>
                        <div class="radio">
                          <input
                            class="phone-radio"
                            value="owner"
                            type="radio"
                            name="bsradio2"
                            @change="handleSharedRadio($event, 'owner', 'Phone bills')"
                            :checked="houseUtilitiesComplete[houseUtilitiesSelected.indexOf('Phone bills')] && houseUtilitiesComplete[houseUtilitiesSelected.indexOf('Phone bills')].paymentType == 'owner'"
                            id="radio7"
                          />
                          <label for="radio7">{{$t('Property Owner')}}</label>
                        </div>
                      </div>
                    </li>
                    <li class="mr-2 mb-1">
                      <div>
                        <div class="radio">
                          <input
                            class="phone-radio"
                            value="fixed_amount"
                            type="radio"
                            name="bsradio2"
                            @change="handleSharedRadio($event, 'tenant_fixed', 'Phone bills')"
                            :checked="houseUtilitiesComplete[houseUtilitiesSelected.indexOf('Phone bills')] && houseUtilitiesComplete[houseUtilitiesSelected.indexOf('Phone bills')].paymentType == 'fixed_amount'"
                            id="radio8"
                          />
                          <label for="radio8">{{$t('Tenant’s fixed amount')}}</label>
                        </div>
                      </div>
                      <div class="row" style="width: 350px; margin-top: 20px;" v-if="phoneFixed">
                        <div class="col">
                          <input
                            type="number"
                            step="1"
                            min="0"
                            class="form-control"
                            :placeholder="$t('currency')"
                            v-model="phoneFixedAmount"
                          />
                        </div>
                        <div class="col">
                          <select class="form-control" v-model="phoneFixedAmountRecurrence">
                            <option value="monthly">{{$t('Monthly')}}</option>
                            <option value="bi-monthly">{{$t('Bi-Monthly')}}</option>
                            <option value="yearly">{{$t('Yearly')}}</option>
                          </select>
                        </div>
                      </div>
                    </li>
                    <li class="mr-2 mb-1">
                      <div>
                        <div class="radio">
                          <input
                            type="radio"
                            class="phone-radio"
                            value="shared_usage"
                            name="bsradio2"
                            @change="handleSharedRadio($event, 'shared', 'Phone bills')"
                            :checked="houseUtilitiesComplete[houseUtilitiesSelected.indexOf('Phone bills')] && houseUtilitiesComplete[houseUtilitiesSelected.indexOf('Phone bills')].paymentType == 'shared_usage'"
                            id="radio9"
                          />
                          <label for="radio9">{{$t('Shared (Tenant’s usage)')}}</label>
                        </div>
                      </div>
                    </li>
                    <li class="mr-2 mb-1">
                      <div>
                        <div class="radio">
                          <input
                            type="radio"
                            class="phone-radio"
                            value="shared_percentage"
                            name="bsradio2"
                            @change="handleSharedRadio($event, 'fixed_percentage', 'Phone bills')"
                            :checked="houseUtilitiesComplete[houseUtilitiesSelected.indexOf('Phone bills')] && houseUtilitiesComplete[houseUtilitiesSelected.indexOf('Phone bills')].paymentType == 'shared_percentage'"
                            id="radio10"
                          />
                          <label for="radio10">{{$t('Shared (Fixed percentage)')}}</label>
                        </div>
                      </div>
                      <div
                        style="display: flex; margin-top: 20px; width: 320px;"
                        v-if="phoneShared"
                      >
                        <p style="float: left; padding-right: 10px;">
                          <strong>{{$t('Tenant')}}</strong>
                          <br />
                          <small>{{ (phonePercentage <= 50) ? phonePercentage : 100 - phonePercentage }}%</small>
                        </p>
                        <input
                          type="range"
                          class="custom-range"
                          id="customRange1"
                          v-model="phonePercentage"
                        />
                        <p style="float: right; padding-left: 10px;">
                          <strong>{{$t('Landlord')}}</strong>
                          <br />
                          <small>{{ (phonePercentage <= 50) ? 100 - phonePercentage : phonePercentage }}%</small>
                        </p>
                      </div>
                    </li>
                  </ul>
                  <button
                    class="btn btn-primary"
                    style="width: 320px"
                    type="button"
                    @click="addNewUtility('Phone bills')"
                  >{{$t('Confirm')}}</button>
                  <hr style="width: 320px; margin-left: 0;" />
                </div>

                <div style="margin-top: 13px;">
                  <div class="checkbox checkbox-primary checkbox-glow">
                    <input
                      class="service-checkbox"
                      value="Municipal taxes"
                      type="checkbox"
                      id="municipal-taxes"
                      :checked="houseUtilitiesSelected.includes('Municipal taxes')"
                      @change="handleServiceCheckbox($event, 'Municipal taxes')"
                    />
                    <label for="municipal-taxes">{{$t('Municipal taxes')}}</label>
                  </div>
                </div>

                <div v-if="municipalDetails">
                  <hr style="width: 320px; margin-left: 0;" />
                  <small>{{$t('Who will be in change of this bill?')}}</small>
                  <ul class="list-unstyled mb-0 mt-1">
                    <li class="mr-2 mb-1">
                      <div>
                        <div class="radio">
                          <input
                            class="municipal-radio"
                            value="tenant"
                            type="radio"
                            name="bsradio3"
                            id="radio11"
                            @change="handleSharedRadio($event, 'tenant', 'Municipal taxes')"
                            :checked="houseUtilitiesComplete[houseUtilitiesSelected.indexOf('Municipal taxes')] && houseUtilitiesComplete[houseUtilitiesSelected.indexOf('Municipal taxes')].paymentType == 'tenant'"
                          />
                          <label for="radio11">{{$t('Tenant')}}</label>
                        </div>
                      </div>
                    </li>
                    <li class="mr-2 mb-1">
                      <div>
                        <div class="radio">
                          <input
                            class="municipal-radio"
                            value="owner"
                            type="radio"
                            name="bsradio3"
                            @change="handleSharedRadio($event, 'owner', 'Municipal taxes')"
                            :checked="houseUtilitiesComplete[houseUtilitiesSelected.indexOf('Municipal taxes')] && houseUtilitiesComplete[houseUtilitiesSelected.indexOf('Municipal taxes')].paymentType == 'owner'"
                            id="radio12"
                          />
                          <label for="radio12">{{$t('Property Owner')}}</label>
                        </div>
                      </div>
                    </li>
                    <li class="mr-2 mb-1">
                      <div>
                        <div class="radio">
                          <input
                            class="municipal-radio"
                            value="fixed_amount"
                            type="radio"
                            name="bsradio3"
                            @change="handleSharedRadio($event, 'tenant_fixed', 'Municipal taxes')"
                            :checked="houseUtilitiesComplete[houseUtilitiesSelected.indexOf('Municipal taxes')] && houseUtilitiesComplete[houseUtilitiesSelected.indexOf('Municipal taxes')].paymentType == 'fixed_amount'"
                            id="radio13"
                          />
                          <label for="radio13">{{$t('Tenant’s fixed amount')}}</label>
                        </div>
                      </div>
                      <div
                        class="row"
                        style="width: 350px; margin-top: 20px;"
                        v-if="municipalFixed"
                      >
                        <div class="col">
                          <input
                            type="number"
                            step="1"
                            min="0"
                            class="form-control"
                            :placeholder="$t('currency')"
                            v-model="municipalFixedAmount"
                          />
                        </div>
                        <div class="col">
                          <select class="form-control" v-model="municipalFixedAmountRecurrence">
                            <option value="monthly">{{$t('Monthly')}}</option>
                            <option value="bi-monthly">{{$t('Bi-Monthly')}}</option>
                            <option value="yearly">{{$t('Yearly')}}</option>
                          </select>
                        </div>
                      </div>
                    </li>
                    <li class="mr-2 mb-1">
                      <div>
                        <div class="radio">
                          <input
                            class="municipal-radio"
                            value="shared_usage"
                            type="radio"
                            name="bsradio3"
                            @change="handleSharedRadio($event, 'shared', 'Municipal taxes')"
                            :checked="houseUtilitiesComplete[houseUtilitiesSelected.indexOf('Municipal taxes')] && houseUtilitiesComplete[houseUtilitiesSelected.indexOf('Municipal taxes')].paymentType == 'shared_usage'"
                            id="radio14"
                          />
                          <label for="radio14">{{$t('Shared (Tenant’s usage)')}}</label>
                        </div>
                      </div>
                    </li>
                    <li class="mr-2 mb-1">
                      <div>
                        <div class="radio">
                          <input
                            class="municipal-radio"
                            value="shared_percentage"
                            type="radio"
                            name="bsradio3"
                            @change="handleSharedRadio($event, 'fixed_percentage', 'Municipal taxes')"
                            :checked="houseUtilitiesComplete[houseUtilitiesSelected.indexOf('Municipal taxes')] && houseUtilitiesComplete[houseUtilitiesSelected.indexOf('Municipal taxes')].paymentType == 'shared_percentage'"
                            id="radio15"
                          />
                          <label for="radio15">{{$t('Shared (Fixed percentage)')}}</label>
                        </div>
                      </div>
                      <div
                        style="display: flex; margin-top: 20px; width: 320px;"
                        v-if="municipalShared"
                      >
                        <p style="float: left; padding-right: 10px;">
                          <strong>{{$t('Tenant')}}</strong>
                          <br />
                          <small>{{ (municipalPercentage <= 50) ? municipalPercentage : 100 - municipalPercentage }}%</small>
                        </p>
                        <input
                          type="range"
                          class="custom-range"
                          id="customRange1"
                          v-model="municipalPercentage"
                        />
                        <p style="float: right; padding-left: 10px;">
                          <strong>{{$t('Landlord')}}</strong>
                          <br />
                          <small>{{ (municipalPercentage <= 50) ? 100 - municipalPercentage : municipalPercentage }}%</small>
                        </p>
                      </div>
                    </li>
                  </ul>
                  <button
                    class="btn btn-primary"
                    style="width: 320px"
                    type="button"
                    @click="addNewUtility('Municipal taxes')"
                  >{{$t('Confirm')}}</button>
                  <hr style="width: 320px; margin-left: 0;" />
                </div>

                <div style="margin-top: 13px;">
                  <div class="checkbox checkbox-primary checkbox-glow">
                    <input
                      class="service-checkbox"
                      value="Ministry of finance taxes"
                      type="checkbox"
                      id="ministry-of-finance"
                      :checked="houseUtilitiesSelected.includes('Ministry of finance taxes')"
                      @change="handleServiceCheckbox($event, 'Ministry of finance taxes')"
                    />
                    <label for="ministry-of-finance">{{$t('Ministry of finance taxes')}}</label>
                  </div>
                </div>

                <div v-if="taxesDetails">
                  <hr style="width: 320px; margin-left: 0;" />
                  <small>{{$t('Who will be in change of this bill?')}}</small>
                  <ul class="list-unstyled mb-0 mt-1">
                    <li class="mr-2 mb-1">
                      <div>
                        <div class="radio">
                          <input
                            class="taxes-radio"
                            value="tenant"
                            type="radio"
                            name="bsradio4"
                            id="radio16"
                            @change="handleSharedRadio($event, 'tenant', 'Ministry of finance taxes')"
                            :checked="houseUtilitiesComplete[houseUtilitiesSelected.indexOf('Ministry of finance taxes')] && houseUtilitiesComplete[houseUtilitiesSelected.indexOf('Ministry of finance taxes')].paymentType == 'tenant'"
                          />
                          <label for="radio16">{{$t('Tenant')}}</label>
                        </div>
                      </div>
                    </li>
                    <li class="mr-2 mb-1">
                      <div>
                        <div class="radio">
                          <input
                            class="taxes-radio"
                            value="owner"
                            type="radio"
                            name="bsradio4"
                            id="radio17"
                            @change="handleSharedRadio($event, 'owner', 'Ministry of finance taxes')"
                            :checked="houseUtilitiesComplete[houseUtilitiesSelected.indexOf('Ministry of finance taxes')] && houseUtilitiesComplete[houseUtilitiesSelected.indexOf('Ministry of finance taxes')].paymentType == 'owner'"
                          />
                          <label for="radio17">{{$t('Property Owner')}}</label>
                        </div>
                      </div>
                    </li>
                    <li class="mr-2 mb-1">
                      <div>
                        <div class="radio">
                          <input
                            class="taxes-radio"
                            value="fixed_amount"
                            type="radio"
                            name="bsradio4"
                            id="radio18"
                            @change="handleSharedRadio($event, 'tenant_fixed', 'Ministry of finance taxes')"
                            :checked="houseUtilitiesComplete[houseUtilitiesSelected.indexOf('Ministry of finance taxes')] && houseUtilitiesComplete[houseUtilitiesSelected.indexOf('Ministry of finance taxes')].paymentType == 'fixed_amount'"
                          />
                          <label for="radio18">{{$t('Tenant’s fixed amount')}}</label>
                        </div>
                      </div>
                      <div class="row" style="width: 350px; margin-top: 20px;" v-if="taxesFixed">
                        <div class="col">
                          <input
                            type="number"
                            step="1"
                            min="0"
                            class="form-control"
                           :placeholder="$t('currency')"
                            v-model="taxesFixedAmount"
                          />
                        </div>
                        <div class="col">
                          <select class="form-control" v-model="taxesFixedAmountRecurrence">
                            <option value="monthly">{{$t('Monthly')}}</option>
                            <option value="bi-monthly">{{$t('Bi-Monthly')}}</option>
                            <option value="yearly">{{$t('Yearly')}}</option>
                          </select>
                        </div>
                      </div>
                    </li>
                    <li class="mr-2 mb-1">
                      <div>
                        <div class="radio">
                          <input
                            class="taxes-radio"
                            value="shared_usage"
                            type="radio"
                            name="bsradio4"
                            id="radio19"
                            @change="handleSharedRadio($event, 'shared', 'Ministry of finance taxes')"
                            :checked="houseUtilitiesComplete[houseUtilitiesSelected.indexOf('Ministry of finance taxes')] && houseUtilitiesComplete[houseUtilitiesSelected.indexOf('Ministry of finance taxes')].paymentType == 'shared_usage'"
                          />
                          <label for="radio19">{{$t('Shared (Tenant’s usage)')}}</label>
                        </div>
                      </div>
                    </li>
                    <li class="mr-2 mb-1">
                      <div>
                        <div class="radio">
                          <input
                            class="taxes-radio"
                            value="shared_percentage"
                            type="radio"
                            name="bsradio4"
                            id="radio20"
                            @change="handleSharedRadio($event, 'fixed_percentage', 'Ministry of finance taxes')"
                            :checked="houseUtilitiesComplete[houseUtilitiesSelected.indexOf('Ministry of finance taxes')] && houseUtilitiesComplete[houseUtilitiesSelected.indexOf('Ministry of finance taxes')].paymentType == 'shared_percentage'"
                          />
                          <label for="radio20">{{$t('Shared (Fixed percentage)')}}</label>
                        </div>
                      </div>
                      <div
                        style="display: flex; margin-top: 20px; width: 320px;"
                        v-if="taxesShared"
                      >
                        <p style="float: left; padding-right: 10px;">
                          <strong>{{$t('Tenant')}}</strong>
                          <br />
                          <small>{{ (taxesPercentage <= 50) ? taxesPercentage : 100 - taxesPercentage }}%</small>
                        </p>
                        <input
                          type="range"
                          class="custom-range"
                          id="customRange1"
                          v-model="taxesPercentage"
                        />
                        <p style="float: right; padding-left: 10px;">
                          <strong>{{$t('Landlord')}}</strong>
                          <br />
                          <small>{{ (taxesPercentage <= 50) ? 100 - taxesPercentage : taxesPercentage }}%</small>
                        </p>
                      </div>
                    </li>
                  </ul>
                  <button
                    class="btn btn-primary"
                    style="width: 320px"
                    type="button"
                    @click="addNewUtility('Ministry of finance taxes')"
                  >{{$t('Confirm')}}</button>
                  <hr style="width: 320px; margin-left: 0;" />
                </div>

                <div style="margin-top: 13px;">
                  <div class="checkbox checkbox-primary checkbox-glow">
                    <input
                      class="service-checkbox"
                      value="Water bills"
                      type="checkbox"
                      id="water-bills"
                      :checked="houseUtilitiesSelected.includes('Water bills')"
                      @change="handleServiceCheckbox($event, 'Water bills')"
                    />
                    <label for="water-bills">{{$t('Water bills')}}</label>
                  </div>
                </div>

                <div v-if="waterDetails">
                  <hr style="width: 320px; margin-left: 0;" />
                  <small>{{$t('Who will be in change of this bill?')}}</small>
                  <ul class="list-unstyled mb-0 mt-1">
                    <li class="mr-2 mb-1">
                      <div>
                        <div class="radio">
                          <input
                            class="water-radio"
                            value="tenant"
                            type="radio"
                            name="bsradio5"
                            id="radio21"
                            :checked="houseUtilitiesComplete[houseUtilitiesSelected.indexOf('Water bills')] && houseUtilitiesComplete[houseUtilitiesSelected.indexOf('Water bills')].paymentType == 'tenant'"
                            @change="handleSharedRadio($event, 'tenant', 'Water bills')"
                          />
                          <label for="radio21">{{$t('Tenant')}}</label>
                        </div>
                      </div>
                    </li>
                    <li class="mr-2 mb-1">
                      <div>
                        <div class="radio">
                          <input
                            class="water-radio"
                            value="owner"
                            type="radio"
                            name="bsradio5"
                            id="radio22"
                            :checked="houseUtilitiesComplete[houseUtilitiesSelected.indexOf('Water bills')] && houseUtilitiesComplete[houseUtilitiesSelected.indexOf('Water bills')].paymentType == 'owner'"
                            @change="handleSharedRadio($event, 'owner', 'Water bills')"
                          />
                          <label for="radio22">{{$t('Property Owner')}}</label>
                        </div>
                      </div>
                    </li>
                    <li class="mr-2 mb-1">
                      <div>
                        <div class="radio">
                          <input
                            class="water-radio"
                            value="fixed_amount"
                            type="radio"
                            name="bsradio5"
                            id="radio23"
                            :checked="houseUtilitiesComplete[houseUtilitiesSelected.indexOf('Water bills')] && houseUtilitiesComplete[houseUtilitiesSelected.indexOf('Water bills')].paymentType == 'fixed_amount'"
                            @change="handleSharedRadio($event, 'tenant_fixed', 'Water bills')"
                          />
                          <label for="radio23">{{$t('Tenant’s fixed amount')}}</label>
                        </div>
                      </div>
                      <div class="row" style="width: 350px; margin-top: 20px;" v-if="waterFixed">
                        <div class="col">
                          <input
                            type="number"
                            step="1"
                            min="0"
                            class="form-control"
                            :placeholder="$t('currency')"
                            v-model="waterFixedAmount"
                          />
                        </div>
                        <div class="col">
                          <select class="form-control" v-model="waterFixedAmountRecurrence">
                            <option value="monthly">{{$t('Monthly')}}</option>
                            <option value="bi-monthly">{{$t('Bi-Monthly')}}</option>
                            <option value="yearly">{{$t('Yearly')}}</option>
                          </select>
                        </div>
                      </div>
                    </li>
                    <li class="mr-2 mb-1">
                      <div>
                        <div class="radio">
                          <input
                            class="water-radio"
                            value="shared_usage"
                            type="radio"
                            name="bsradio5"
                            id="radio24"
                            :checked="houseUtilitiesComplete[houseUtilitiesSelected.indexOf('Water bills')] && houseUtilitiesComplete[houseUtilitiesSelected.indexOf('Water bills')].paymentType == 'shared_usage'"
                            @change="handleSharedRadio($event, 'tenant_fixed', 'Water bills')"
                          />
                          <label for="radio24">{{$t('Shared (Tenant’s usage)')}}</label>
                        </div>
                      </div>
                    </li>
                    <li class="mr-2 mb-1">
                      <div>
                        <div class="radio">
                          <input
                            class="water-radio"
                            value="shared_percentage"
                            type="radio"
                            name="bsradio5"
                            id="radio25"
                            :checked="houseUtilitiesComplete[houseUtilitiesSelected.indexOf('Water bills')] && houseUtilitiesComplete[houseUtilitiesSelected.indexOf('Water bills')].paymentType == 'shared_percentage'"
                            @change="handleSharedRadio($event, 'fixed_percentage', 'Water bills')"
                          />
                          <label for="radio25">{{$t('Shared (Fixed percentage)')}}</label>
                        </div>
                      </div>
                      <div
                        style="display: flex; margin-top: 20px; width: 320px;"
                        v-if="waterShared"
                      >
                        <p style="float: left; padding-right: 10px;">
                          <strong>{{$t('Tenant')}}</strong>
                          <br />
                          <small>{{ (waterPercentage <= 50) ? waterPercentage : 100 - waterPercentage }}%</small>
                        </p>
                        <input
                          type="range"
                          class="custom-range"
                          id="customRange1"
                          v-model="waterPercentage"
                        />
                        <p style="float: right; padding-left: 10px;">
                          <strong>{{$t('Landlord')}}</strong>
                          <br />
                          <small>{{ (waterPercentage <= 50) ? 100 - waterPercentage : waterPercentage }}%</small>
                        </p>
                      </div>
                    </li>
                  </ul>
                  <button
                    class="btn btn-primary"
                    style="width: 320px"
                    type="button"
                    @click="addNewUtility('Water bills')"
                  >{{$t('Confirm')}}</button>
                  <hr style="width: 320px; margin-left: 0;" />
                </div>

                <div style="margin-top: 13px;">
                  <div class="checkbox checkbox-primary checkbox-glow">
                    <input
                      class="service-checkbox"
                      value="Septic/Seawage bills"
                      type="checkbox"
                      id="septic"
                      :checked="houseUtilitiesSelected.includes('Septic/Seawage bills')"
                      @change="handleServiceCheckbox($event, 'Septic/Seawage bills')"
                    />
                    <label for="septic">{{$t('Septic/Seawage bills')}}</label>
                  </div>
                </div>

                <div v-if="septicDetails">
                  <hr style="width: 320px; margin-left: 0;" />
                  <small>{{$t('Who will be in change of this bill?')}}</small>
                  <ul class="list-unstyled mb-0 mt-1">
                    <li class="mr-2 mb-1">
                      <div>
                        <div class="radio">
                          <input
                            class="septic-radio"
                            value="tenant"
                            type="radio"
                            name="bsradio6"
                            id="radio26"
                            :checked="houseUtilitiesComplete[houseUtilitiesSelected.indexOf('Septic/Seawage bills')] && houseUtilitiesComplete[houseUtilitiesSelected.indexOf('Septic/Seawage bills')].paymentType == 'tenant'"
                            @change="handleSharedRadio($event, 'tenant', 'Septic/Seawage bills')"
                          />
                          <label for="radio26">{{$t('Tenant')}}</label>
                        </div>
                      </div>
                    </li>
                    <li class="mr-2 mb-1">
                      <div>
                        <div class="radio">
                          <input
                            class="septic-radio"
                            value="owner"
                            type="radio"
                            name="bsradio6"
                            id="radio27"
                            :checked="houseUtilitiesComplete[houseUtilitiesSelected.indexOf('Septic/Seawage bills')] && houseUtilitiesComplete[houseUtilitiesSelected.indexOf('Septic/Seawage bills')].paymentType == 'owner'"
                            @change="handleSharedRadio($event, 'owner', 'Septic/Seawage bills')"
                          />
                          <label for="radio27">{{$t('Property Owner')}}</label>
                        </div>
                      </div>
                    </li>
                    <li class="mr-2 mb-1">
                      <div>
                        <div class="radio">
                          <input
                            class="septic-radio"
                            value="fixed_amount"
                            type="radio"
                            name="bsradio6"
                            id="radio28"
                            :checked="houseUtilitiesComplete[houseUtilitiesSelected.indexOf('Septic/Seawage bills')] && houseUtilitiesComplete[houseUtilitiesSelected.indexOf('Septic/Seawage bills')].paymentType == 'fixed_amount'"
                            @change="handleSharedRadio($event, 'tenant_fixed', 'Septic/Seawage bills')"
                          />
                          <label for="radio28">{{$t('Tenant’s fixed amount')}}</label>
                        </div>
                      </div>
                      <div class="row" style="width: 350px; margin-top: 20px;" v-if="septicFixed">
                        <div class="col">
                          <input
                            type="number"
                            step="1"
                            min="0"
                            class="form-control"
                            :placeholder="$t('currency')"
                            v-model="septicFixedAmount"
                          />
                        </div>
                        <div class="col">
                          <select class="form-control" v-model="septicFixedAmountRecurrence">
                            <option value="monthly">{{$t('Monthly')}}</option>
                            <option value="bi-monthly">{{$t('Bi-Monthly')}}</option>
                            <option value="yearly">{{$t('Yearly')}}</option>
                          </select>
                        </div>
                      </div>
                    </li>
                    <li class="mr-2 mb-1">
                      <div>
                        <div class="radio">
                          <input
                            class="septic-radio"
                            value="shared_usage"
                            type="radio"
                            name="bsradio6"
                            id="radio29"
                            :checked="houseUtilitiesComplete[houseUtilitiesSelected.indexOf('Septic/Seawage bills')] && houseUtilitiesComplete[houseUtilitiesSelected.indexOf('Septic/Seawage bills')].paymentType == 'shared_usage'"
                            @change="handleSharedRadio($event, 'shared', 'Septic/Seawage bills')"
                          />
                          <label for="radio29">{{$t('Shared (Tenant’s usage)')}}</label>
                        </div>
                      </div>
                    </li>
                    <li class="mr-2 mb-1">
                      <div>
                        <div class="radio">
                          <input
                            class="septic-radio"
                            value="shared_percentage"
                            type="radio"
                            name="bsradio6"
                            id="radio30"
                            :checked="houseUtilitiesComplete[houseUtilitiesSelected.indexOf('Septic/Seawage bills')] && houseUtilitiesComplete[houseUtilitiesSelected.indexOf('Septic/Seawage bills')].paymentType == 'shared_percentage'"
                            @change="handleSharedRadio($event, 'fixed_percentage', 'Septic/Seawage bills')"
                          />
                          <label for="radio30">{{$t('Shared (Fixed percentage)')}}</label>
                        </div>
                      </div>
                      <div
                        style="display: flex; margin-top: 20px; width: 320px;"
                        v-if="septicShared"
                      >
                        <p style="float: left; padding-right: 10px;">
                          <strong>{{$t('Tenant')}}</strong>
                          <br />
                          <small>{{ (septicPercentage <= 50) ? septicPercentage : 100 - septicPercentage }}%</small>
                        </p>
                        <input
                          type="range"
                          class="custom-range"
                          id="customRange1"
                          v-model="septicPercentage"
                        />
                        <p style="float: right; padding-left: 10px;">
                          <strong>{{$t('Landlord')}}</strong>
                          <br />
                          <small>{{ (septicPercentage <= 50) ? 100 - septicPercentage : septicPercentage }}%</small>
                        </p>
                      </div>
                    </li>
                  </ul>
                  <button
                    class="btn btn-primary"
                    style="width: 320px"
                    type="button"
                    @click="addNewUtility('Septic/Seawage bills')"
                  >{{$t('Confirm')}}</button>
                  <hr style="width: 320px; margin-left: 0;" />
                </div>

                <div v-if="house.info && house.info.utilities">
                  <div v-for="(utility, index) in house.info.utilities" :key="index">
                    <div v-if="!defaultServices.includes(utility.name)">
                      <div style="margin-top: 13px;">
                        <div class="checkbox checkbox-primary checkbox-glow">
                          <input
                            class="service-checkbox"
                            :value="utility.name"
                            type="checkbox"
                            :id="utility.name.replaceAll(' ', '_').toLowerCase()"
                            @change="handleNewUtilityCheckboxCustomLoad($event, utility)"
                            checked
                          />
                          <label :for="utility.name.replaceAll(' ', '_').toLowerCase()">{{ utility.name }}</label>
                        </div>
                      </div>

                      <div :id="`payment-deatils-${utility.name.replaceAll(' ', '_').toLowerCase()}`" class="hidden">
                        <hr style="width: 320px; margin-left: 0;" />
                        <small>{{$t('Who will be in change of this bill?')}}</small>

                        <ul class="list-unstyled mb-0 mt-1">
                          <li class="mr-2 mb-1">
                            <div>
                              <div class="radio">
                                <input
                                  :class="`${utility.name.replaceAll(' ', '_').toLowerCase()}-radio`"
                                  value="tenant"
                                  type="radio"
                                  :name="`bsradio-custom-${index}`"
                                  :id="`tenant-radio-${index}`"
                                  @change="handleCustomUtilityCustomLoad($event, utility, 'tenant')"
                                />
                                <label :for="`tenant-radio-${index}`">{{$t('Tenant')}}</label>
                              </div>
                            </div>
                          </li>
                          <li class="mr-2 mb-1">
                            <div>
                              <div class="radio">
                                <input
                                  :class="`${utility.name.replaceAll(' ', '_').toLowerCase()}-radio`"
                                  value="owner"
                                  type="radio"
                                  :name="`bsradio-custom-${index}`"
                                  :id="`owner-radio-${index}`"
                                  @change="handleCustomUtilityCustomLoad($event, utility, 'owner')"
                                />
                                <label :for="`owner-radio-${index}`">{{$t('Property Owner')}}</label>
                              </div>
                            </div>
                          </li>
                          <li class="mr-2 mb-1">
                            <div>
                              <div class="radio">
                                <input
                                  :class="`${utility.name.replaceAll(' ', '_').toLowerCase()}-radio`"
                                  value="fixed_amount"
                                  type="radio"
                                  :name="`bsradio-custom-${index}`"
                                  :id="`tenant-fixed-radio-${index}`"
                                  @change="handleCustomUtilityCustomLoad($event, utility, 'tenant_fixed')"
                                />
                                <label :for="`tenant-fixed-radio-${index}`">{{$t('Tenant’s fixed amount')}}</label>
                              </div>
                            </div>
                            <div class="row hidden" style="width: 350px; margin-top: 20px;" :id="`tenant-fixed-details-${utility.name.replaceAll(' ', '_').toLowerCase()}`">
                              <div class="col">
                                <input
                                  type="number"
                                  step="1"
                                  min="0"
                                  class="form-control"
                                  :placeholder="$t('currency')"
                                  :id="`tenant-fixed-details-value-${utility.name.replaceAll(' ', '_').toLowerCase()}`"
                                  value="0"
                                />
                              </div>
                              <div class="col">
                                <select class="form-control" :id="`tenant-fixed-details-month-${utility.name.replaceAll(' ', '_').toLowerCase()}`">
                                  <option value="monthly">{{$t('Monthly')}}</option>
                                  <option value="bi-monthly">{{$t('Bi-Monthly')}}</option>
                                  <option value="yearly">{{$t('Yearly')}}</option>
                                </select>
                              </div>
                            </div>
                          </li>
                          <li class="mr-2 mb-1">
                            <div>
                              <div class="radio">
                                <input
                                  :class="`${utility.name.replaceAll(' ', '_').toLowerCase()}-radio`"
                                  value="shared_usage"
                                  type="radio"
                                  :name="`bsradio-custom-${index}`"
                                  :id="`tenant-shared-radio-${index}`"
                                  @change="handleCustomUtilityCustomLoad($event, utility, 'tenant_shared')"
                                />
                                <label :for="`tenant-shared-radio-${index}`">{{$t('Shared (Tenant’s usage)')}}</label>
                              </div>
                            </div>
                          </li>
                          <li class="mr-2 mb-1">
                            <div>
                              <div class="radio">
                                <input
                                  :class="`${utility.name.replaceAll(' ', '_').toLowerCase()}-radio`"
                                  value="shared_percentage"
                                  type="radio"
                                  :name="`bsradio-custom-${index}`"
                                  :id="`fixed-shared-radio-${index}`"
                                  @change="handleCustomUtilityCustomLoad($event, utility, 'fixed_shared')"
                                />
                                <label :for="`fixed-shared-radio-${index}`">Shared (Fixed percentage)</label>
                              </div>
                            </div>
                            <div
                              style="margin-top: 20px; width: 320px; display: none;"
                              :id="`fixed-shared-details-${utility.name.replaceAll(' ', '_').toLowerCase()}`"
                            >
                              <p style="float: left; padding-right: 10px;">
                                <strong>Tenant</strong>
                                <br />
                                <small :id="`small-tenant-${utility.name.replaceAll(' ', '_').toLowerCase()}`">
                                  {{ (sliderForm.slider_id[index]) ? (sliderForm.slider_id[index] <= 50) ? sliderForm.slider_id[index] : 100 - sliderForm.slider_id[index] : 50 }}%
                                </small>
                              </p>
                              <input
                                type="range"
                                class="custom-range"
                                :id="`fixed-shared-slider-${utility.name.replaceAll(' ', '_').toLowerCase()}`"
                                v-model="sliderForm.slider_id[index]"
                              />
                              <p style="float: right; padding-left: 10px;">
                                <strong>Landlord</strong>
                                <br />
                                <small :id="`small-landlord-${utility.name.replaceAll(' ', '_').toLowerCase()}`">
                                  {{ (sliderForm.slider_id[index]) ? (sliderForm.slider_id[index] <= 50) ? 100 - sliderForm.slider_id[index] : sliderForm.slider_id[index] : 50 }}%
                                </small>
                              </p>
                            </div>
                          </li>
                        </ul>

                        <button
                          class="btn btn-primary"
                          style="width: 320px"
                          type="button"
                          @click="confirmCustomUtilityCustomLoad(utility)"
                        >{{$t('Confirm')}}</button>
                        <hr style="width: 320px; margin-left: 0;" />
                      </div>
                    </div>
                  </div>
                </div>



                <!-- ADD CUSTOM UTILITY -->
                <div v-if="showCustomUtility && customUitilities.length">
                  <div v-for="(utility, index) in customUitilities" :key="index">
                    <div style="margin-top: 13px;">
                      <div class="checkbox checkbox-primary checkbox-glow">
                        <input
                          class="service-checkbox"
                          :value="utility.name"
                          type="checkbox"
                          :id="utility.uuid"
                          @change="handleNewUtilityCheckbox($event, utility)"
                          checked
                        />
                        <label :for="utility.uuid">{{ utility.name }}</label>
                      </div>
                    </div>

                    <div :id="`payment-deatils-${utility.uuid}`">
                      <hr style="width: 320px; margin-left: 0;" />
                      <small>{{$t('Who will be in change of this bill?')}}</small>

                      <ul class="list-unstyled mb-0 mt-1">
                        <li class="mr-2 mb-1">
                          <div>
                            <div class="radio">
                              <input
                                :class="`${utility.uuid}-radio`"
                                value="tenant"
                                type="radio"
                                :name="`bsradio-custom-${index}`"
                                :id="`tenant-radio-${index}`"
                                @change="handleCustomUtility($event, utility, 'tenant')"
                              />
                              <label :for="`tenant-radio-${index}`">Tenant</label>
                            </div>
                          </div>
                        </li>
                        <li class="mr-2 mb-1">
                          <div>
                            <div class="radio">
                              <input
                                :class="`${utility.uuid}-radio`"
                                value="owner"
                                type="radio"
                                :name="`bsradio-custom-${index}`"
                                :id="`owner-radio-${index}`"
                                @change="handleCustomUtility($event, utility, 'owner')"
                              />
                              <label :for="`owner-radio-${index}`">Property Owner</label>
                            </div>
                          </div>
                        </li>
                        <li class="mr-2 mb-1">
                          <div>
                            <div class="radio">
                              <input
                                :class="`${utility.uuid}-radio`"
                                value="fixed_amount"
                                type="radio"
                                :name="`bsradio-custom-${index}`"
                                :id="`tenant-fixed-radio-${index}`"
                                @change="handleCustomUtility($event, utility, 'tenant_fixed')"
                              />
                              <label :for="`tenant-fixed-radio-${index}`">{{$t('Tenant’s fixed amount')}}</label>
                            </div>
                          </div>
                          <div class="row hidden" style="width: 350px; margin-top: 20px;" :id="`tenant-fixed-details-${utility.uuid}`">
                            <div class="col">
                              <input
                                type="number"
                                step="1"
                                min="0"
                                class="form-control"
                                :placeholder="$t('currency')"
                                :id="`tenant-fixed-details-value-${utility.uuid}`"
                                value="0"
                              />
                            </div>
                            <div class="col">
                              <select class="form-control" :id="`tenant-fixed-details-month-${utility.uuid}`">
                                <option value="monthly">{{$t('Monthly')}}</option>
                                <option value="bi-monthly">{{$t('Bi-Monthly')}}</option>
                                <option value="yearly">{{$t('Yearly')}}</option>
                              </select>
                            </div>
                          </div>
                        </li>
                        <li class="mr-2 mb-1">
                          <div>
                            <div class="radio">
                              <input
                                :class="`${utility.uuid}-radio`"
                                value="shared_usage"
                                type="radio"
                                :name="`bsradio-custom-${index}`"
                                :id="`tenant-shared-radio-${index}`"
                                @change="handleCustomUtility($event, utility, 'tenant_shared')"
                              />
                              <label :for="`tenant-shared-radio-${index}`">{{$t('Shared (Tenant’s usage)')}}</label>
                            </div>
                          </div>
                        </li>
                        <li class="mr-2 mb-1">
                          <div>
                            <div class="radio">
                              <input
                                :class="`${utility.uuid}-radio`"
                                value="shared_percentage"
                                type="radio"
                                :name="`bsradio-custom-${index}`"
                                :id="`fixed-shared-radio-${index}`"
                                @change="handleCustomUtility($event, utility, 'fixed_shared')"
                              />
                              <label :for="`fixed-shared-radio-${index}`">{{$t('Shared (Fixed percentage)')}}</label>
                            </div>
                          </div>
                          <div
                            style="margin-top: 20px; width: 320px; display: none;"
                            :id="`fixed-shared-details-${utility.uuid}`"
                          >
                            <p style="float: left; padding-right: 10px;">
                              <strong>Tenant</strong>
                              <br />
                              <small :id="`small-tenant-${utility.uuid}`">
                                {{ (sliderForm.slider_id[index]) ? (sliderForm.slider_id[index] <= 50) ? sliderForm.slider_id[index] : 100 - sliderForm.slider_id[index] : 50 }}%
                              </small>
                            </p>
                            <input
                              type="range"
                              class="custom-range"
                              :id="`fixed-shared-slider-${utility.uuid}`"
                              v-model="sliderForm.slider_id[index]"
                            />
                            <p style="float: right; padding-left: 10px;">
                              <strong>Landlord</strong>
                              <br />
                              <small :id="`small-landlord-${utility.uuid}`">
                                {{ (sliderForm.slider_id[index]) ? (sliderForm.slider_id[index] <= 50) ? 100 - sliderForm.slider_id[index] : sliderForm.slider_id[index] : 50 }}%
                              </small>
                            </p>
                          </div>
                        </li>
                      </ul>

                      <button
                        class="btn btn-primary"
                        style="width: 320px"
                        type="button"
                        @click="confirmCustomUtility(utility)"
                      >{{$t('Confirm')}}</button>
                      <hr style="width: 320px; margin-left: 0;" />
                    </div>
                  </div>
                </div>

                <div style="margin-top: 15px; width: 50%;">
                  <div class="input-group">
                    <input
                      type="text"
                      class="form-control"
                      :placeholder="$t('Others, internet, cleaning, etc…')"
                      aria-describedby="button-add-service-item"
                      v-model="customUtility"
                    />
                    <div class="input-group-append" id="button-add-service-item">
                      <button class="btn btn-primary" type="button" @click="addCustomUtility()">
                        <em class="bx bx-plus"></em>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-sm-12">
                <h4 style="margin-bottom: 17px;">{{$t('Inventory')}}</h4>
                <div style="width: 50%;">
                  <label for>{{$t('Status')}}</label>
                  <select
                    class="form-control"
                    v-model="inventoryStatus"
                    @change="handleInventoryStatusSelect()"
                  >
                    <option value="Choose status..." selected disabled>{{$t('Choose status...')}}</option>
                    <option value="furnished">{{$t('Furnished')}}</option>
                    <option value="partially">{{$t('Partially')}}</option>
                    <option value="unfurnished">{{$t('Unfurnished')}}</option>
                  </select>

                  <div v-if="canShowInventory" class="mt-2">
                    <span v-for="(item, index) in houseInventory" :key="index">
                      <em
                        class="bx bx-minus-circle"
                        style="float: right; margin-right: 8px; cursor: pointer;"
                        @click="deleteInventoryItem(index)"
                      ></em>
                      <p class="inventory-item">{{ item }}</p>
                    </span>
                    <div style="margin-top: 15px;">
                      <div class="input-group">
                        <input
                          type="text"
                          class="form-control"
                         :placeholder="$t('More…')"
                          aria-describedby="button-add-inventory-item"
                          v-model="newInventoryItem"
                        />
                        <div class="input-group-append" id="button-add-inventory-item">
                          <button
                            class="btn btn-primary"
                            type="button"
                            @click="addInventoryItem(newInventoryItem)"
                          >
                            <em class="bx bx-plus"></em>
                          </button>
                        </div>
                      </div>
                    </div>
                    <small>{{ houseInventory.length }} {{$t('elements added')}}</small>
                  </div>
                </div>
              </div>
            </div>

            <div class="row" style="margin-top: 50px;">
              <div class="col-md-6 col-sm-12">
                <h4>{{$t('Other property features')}}</h4>

                <div style="margin-top: 13px;" class="mt-1" v-for="(feature, index) in features" :key="index">
                  <div class="checkbox checkbox-primary checkbox-glow">
                    <input
                      class="feature-checkbox"
                      :value="feature"
                      type="checkbox"
                      :id="`checkbox-${feature.toLowerCase().replaceAll(' ', '_')}`"
                      :checked="selectedFeatures.includes(feature)"
                      @change="handleFeatureSelect(feature)"
                    />
                    <label style="text-transform: capitalize;" :for="`checkbox-${feature.toLowerCase().replaceAll(' ', '_')}`">{{ feature }}</label>
                  </div>
                </div>

                <div style="margin-top: 15px; width: 50%;">
                  <div class="input-group">
                    <input
                      type="text"
                      class="form-control"
                      :placeholder="$t('More…')"
                      aria-describedby="button-add-feature-item"
                      v-model="newFeature"
                    />
                    <div class="input-group-append" id="button-add-feature-item">
                      <button
                        class="btn btn-primary"
                        type="button"
                        @click="addFeature(newFeature)"
                      >
                        <em class="bx bx-plus"></em>
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-6 col-sm-12">
                <div style="width: 50%;">
                  <h4 class="mb-2">{{$t('House rules')}}</h4>

                  <span v-for="(item, index) in houseRules" :key="index">
                    <em
                      class="bx bx-minus-circle"
                      style="float: right; margin-right: 8px; cursor: pointer;"
                      @click="deleteRule(index)"
                    ></em>
                    <p class="inventory-item">{{ item }}</p>
                  </span>

                  <div style="margin-top: 15px;">
                    <div class="input-group">
                      <input
                        type="text"
                        class="form-control"
                        :placeholder="$t('No pets allowed, Quiet hours 12:00 - 06:00...')"
                        aria-describedby="button-add-rule-item"
                        v-model="newRuleItem"
                      />
                      <div class="input-group-append" id="button-add-rule-item">
                        <button
                          class="btn btn-primary"
                          type="button"
                          @click="addRule(newRuleItem)"
                        >
                          <em class="bx bx-plus"></em>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="text-right mt-2">
            <button class="btn btn-primary" type="button" @click="editHouse()">{{$t('Save Changes')}}</button>
          </div>
        </form>
      </div>
    </div>

    <!-- Image Detail -->
    <div
      class="modal fade"
      id="zoom-image-modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="create-modal-title"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-lg"
        role="document"
      >
        <div class="modal-content">
          <div class="modal-body p-0">
            <img :src="zoomedImage" class="w-100" alt="house img" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "@/app-assets/js/scripts/extensions/ext-component-block-ui.js";
import { Cropper } from "vue-advanced-cropper";
import 'vue-advanced-cropper/dist/style.css';
import Alert from "@/components/Alerts";
import ProposalsTableComponent from "@/components/Contracts/ProposalsTableComponent";
import ContractsTableComponent from "@/components/Contracts/ContractsTableComponent";
import { getCountryName } from "@/app-assets/js/get-countries.js";
import { v4 as generate_UUID } from 'uuid';
import { getApp } from 'firebase/app';
import { getAuth, signInWithCustomToken } from 'firebase/auth'
import { getStorage, ref, uploadString, getDownloadURL } from 'firebase/storage';

export default {
  props: ["house", "owner", "rent", "contractsData"],

  components: {
    Cropper,
    Alert,
    ProposalsTableComponent,
    ContractsTableComponent
  },

  data() {
    return {
      sliderForm: {
        slider_id: []
      },
      defaultServices: [
        "Electricity costs", "Phone bills",
        "Municipal taxes", "Ministry of finance taxes",
        "Water bills", "Septic/Seawage bills"
      ],

      error: "",
      errorText: "",
      reject: false,
      errorReject: false,
      editingHouse: false,
      rejectReason: "",
      activeCountries: [],
      tokenData:'',

      houseName: "",
      houseCountry: "",
      houseCity: "",
      houseZip: "",
      houseStreet: "",
      houseBuildingName: "",
      houseRegistryNumber: "",
      houseAdditional: "",
      houseDescription: "",

      availableDate: "",
      askingRent: "",
      currency: "",
      askingDeposit: "",
      askingAdvanceMonths: "",
      houseType: "",
      houseSize: "",
      maxTenants: "",
      floor: "",
      kitchens: "",
      sharedKitchen: false,
      livingRooms: "",
      bedrooms: "",
      bathrooms: "",
      sharedBathrooms: false,
      condition: "Choose condition...",
      conditionDescription: "",
      defects: "",

      houseInventory: [],
      newInventoryItem: "",
      inventoryStatus: "Choose status...",
      canShowInventory: false,

      // Utilities
      houseUtilities: [],
      houseUtilitiesSelected: [],
      houseUtilitiesComplete: [],
      customUitilities: [],

      electricityDetails: false,
      phoneDetails: false,
      municipalDetails: false,
      taxesDetails: false,
      waterDetails: false,
      septicDetails: false,

      electricityPercentage: 50,
      phonePercentage: 50,
      municipalPercentage: 50,
      taxesPercentage: 50,
      waterPercentage: 50,
      septicPercentage: 50,

      electricityShared: false,
      phoneShared: false,
      municipalShared: false,
      taxesShared: false,
      waterShared: false,
      septicShared: false,

      electricityFixed: false,
      phoneFixed: false,
      municipalFixed: false,
      taxesFixed: false,
      waterFixed: false,
      septicFixed: false,

      electricityFixedAmount: 0,
      phoneFixedAmount: 0,
      municipalFixedAmount: 0,
      taxesFixedAmount: 0,
      waterFixedAmount: 0,
      septicFixedAmount: 0,

      electricityFixedAmountRecurrence: "monthly",
      phoneFixedAmountRecurrence: "monthly",
      municipalFixedAmountRecurrence: "monthly",
      taxesFixedAmountRecurrence: "monthly",
      waterFixedAmountRecurrence: "monthly",
      septicFixedAmountRecurrence: "monthly",

      customUtility: "",
      showCustomUtility: false,

      zoomedImage: "",
      image: null,

      negotiationInProcess: false,
			coordinates: {
				width: 0,
				height: 0,
				left: 0,
				top: 0,
			},

      houseStatus: "",
      selectedFeatures: [],
      features: [
        'balcony', 'cellar', 'garden',
        'shared laundry', 'elevator'
      ],
      newFeature: '',

      houseRules: [],
      newRuleItem: ''
    };
  },

  methods: {
    canDelete() {
      if (!this.contractsData.length) return true;
      const signedContracts = this.contractsData.filter(x => x.status === 'active');
      if (!signedContracts.length) return true;

      return false;
    },

    deleteRule(index) {
      this.houseRules.splice(index, 1);
    },

    addRule(item) {
      if(item.trim() !== '') {
        this.houseRules.push(item);
        this.newRuleItem = "";
      }
    },
    getToken() {
      let self = this;
      this.$apiCall.get(`v1/me/customToken`).then((response) => {
        self.tokenData = response.data;
      })
    },

    addFeature(feature) {
      if(feature.trim() !== '') {
        this.features.push(feature);
        this.selectedFeatures.push(feature);
        this.newFeature = '';
      }
    },

    handleFeatureSelect(feature) {
      const self = this;
      this.selectedFeatures = [];
      $(".feature-checkbox").each(function(e) {
        if($(this).is(":checked")){
          self.selectedFeatures.push($(this).val());
        }
      })

      console.log(this.selectedFeatures);
    },

    handleNewUtilityCheckbox(evt, utility) {
      if(evt.target.checked){
        $(`#payment-deatils-${utility.uuid}`).removeClass("hidden");
      } else{
        $(`#payment-deatils-${utility.uuid}`).addClass("hidden");
      }
    },

    handleNewUtilityCheckboxCustomLoad(evt, utility) {
      if(evt.target.checked){
        $(`#payment-deatils-${utility.name.replaceAll(' ', '_').toLowerCase()}`).removeClass("hidden");
      } else{
        $(`#payment-deatils-${utility.name.replaceAll(' ', '_').toLowerCase()}`).addClass("hidden");
      }
    },

    handleCustomUtility(evt, utility, paymentType) {

      $(`#tenant-fixed-details-${utility.uuid}`).addClass("hidden");
      $(`#fixed-shared-details-${utility.uuid}`).css("display", "none");

      if(evt.target.checked && paymentType === 'tenant_fixed') {
        $(`#tenant-fixed-details-${utility.uuid}`).removeClass("hidden");
      }

      if(evt.target.checked && paymentType === 'fixed_shared'){
        $(`#fixed-shared-details-${utility.uuid}`).css("display", "flex");
      }
    },

    handleCustomUtilityCustomLoad(evt, utility, paymentType) {

      $(`#tenant-fixed-details-${utility.name.replaceAll(' ', '_').toLowerCase()}`).addClass("hidden");
      $(`#fixed-shared-details-${utility.name.replaceAll(' ', '_').toLowerCase()}`).css("display", "none");

      if(evt.target.checked && paymentType === 'tenant_fixed') {
        $(`#tenant-fixed-details-${utility.name.replaceAll(' ', '_').toLowerCase()}`).removeClass("hidden");
      }

      if(evt.target.checked && paymentType === 'fixed_shared'){
        $(`#fixed-shared-details-${utility.name.replaceAll(' ', '_').toLowerCase()}`).css("display", "flex");
      }
    },

    confirmCustomUtility(utility) {
      let ut = {
        name: utility.name
      };

      $(`.${utility.uuid}-radio`).each(function() {
        if ($(this).is(":checked")) {
          ut.paymentType = $(this).val();
        }
      })

      if (!ut.paymentType) {
        ut.paymentType = "tenant";
      }

      if(ut.paymentType === 'fixed_amount'){
        ut.amount = Number($(`#tenant-fixed-details-value-${utility.uuid}`).val());
        ut.recurrencr = $(`#tenant-fixed-details-month-${utility.uuid}`).val();
      }

      if(ut.paymentType === 'shared_percentage'){
        let am = $(`#fixed-shared-slider-${utility.uuid}`).val()
        ut.amount = Number((am <= 50) ? am : 100 - am);
      }

      $(`#payment-deatils-${utility.uuid}`).addClass("hidden");
      this.houseUtilities.push(ut);

      console.log("New Utility", ut);
    },

    confirmCustomUtilityCustomLoad(utility) {
      let ut = {
        name: utility.name
      };

      $(`.${utility.name.replaceAll(' ', '_').toLowerCase()}-radio`).each(function() {
        if ($(this).is(":checked")) {
          ut.paymentType = $(this).val();
        }
      })

      if (!ut.paymentType) {
        ut.paymentType = "tenant";
      }

      if(ut.paymentType === 'fixed_amount'){
        ut.amount = Number($(`#tenant-fixed-details-value-${utility.name.replaceAll(' ', '_').toLowerCase()}`).val());
        ut.recurrencr = $(`#tenant-fixed-details-month-${utility.name.replaceAll(' ', '_').toLowerCase()}`).val();
      }

      if(ut.paymentType === 'shared_percentage'){
        let am = $(`#fixed-shared-slider-${utility.name.replaceAll(' ', '_').toLowerCase()}`).val()
        ut.amount = Number((am <= 50) ? am : 100 - am);
      }

      $(`#payment-deatils-${utility.name.replaceAll(' ', '_').toLowerCase()}`).addClass("hidden");
      this.houseUtilities.push(ut);

      console.log("New Utility", ut);
    },

    addCustomUtility(){
      let utility = {
        name: this.customUtility,
        uuid: this.customUtility.replaceAll(' ', '_').toLowerCase()
      };

      this.customUitilities.push(utility);
      this.customUtility = '';

      this.showCustomUtility = true;
    },

    deleteProperty() {
      $.blockUI({
        message: '<div class="bx bx-revision icon-spin font-medium-2"></div>',
        overlayCSS: {
          backgroundColor: "#fff",
          opacity: 0.8,
          cursor: "wait",
        },
        css: {
          border: 0,
          padding: 0,
          backgroundColor: "transparent",
        },
      });
      this.$apiCall.delete(`/v1/properties/${this.house.uid}`)
      .then(response => {
        location.href = '/houses';
      })
      .catch(error => {
        $.unblockUI();
        this.error = "error-message";
        this.errorText = `$t('Ops') ${error.response.data.message}`;
        $("html, body").animate(
          {
            scrollTop: $("body").offset().top,
          },
          500
        );
      })
    },

    storeImage() {
      let self = this;
      const { coordinates, canvas, } = this.$refs.cropper.getResult();
      this.coordinates = coordinates;

      $.blockUI({
        message: '<div class="bx bx-revision icon-spin font-medium-2"></div>',
        overlayCSS: {
          backgroundColor: "#fff",
          opacity: 0.8,
          cursor: "wait",
        },
        css: {
          border: 0,
          padding: 0,
          backgroundColor: "transparent",
        },
      });
      let imageNameUUID = generate_UUID();
      const firebaseApp = getApp();
      const firebaseAuth = getAuth(firebaseApp);
      signInWithCustomToken(firebaseAuth, self.tokenData)
          .then((userCredential) => {
            console.log("token userCredential", self.tokenData);
      const storage = getStorage(firebaseApp)
      const imageReference = ref(storage,`/images/${imageNameUUID}`);

      uploadString(imageReference, canvas.toDataURL(), 'data_url')
      .then(() => getDownloadURL(imageReference))
      .then(url => {
        this.image = null;
        if(this.house.photos){
          this.house.photos.push(url)
        } else{
          this.house.photos = [url];
        }
        $.unblockUI();
      })
    })
    },

    uploadImage(event) {
      $.blockUI({
        message: '<div class="bx bx-revision icon-spin font-medium-2"></div>',
        overlayCSS: {
          backgroundColor: "#fff",
          opacity: 0.8,
          cursor: "wait",
        },
        css: {
          border: 0,
          padding: 0,
          backgroundColor: "transparent",
        },
      });
      var input = event.target;
      if (input.files && input.files[0]) {
        let reader = new FileReader();
        reader.onload = (e) => {
          this.image = e.target.result;
        };
        reader.readAsDataURL(input.files[0]);
        $.unblockUI();
        // $("#crop-image-modal").modal();
      }
    },

    handleInventoryStatusSelect() {
      let status = this.inventoryStatus;
      this.canShowInventory = false;

      if (status == "furnished" || status == "partially") {
        this.canShowInventory = true;
      }
    },

    countryName(element) {
      if (element) {
        return getCountryName(element.toUpperCase());
      }
    },

    approveProperty() {
      $.blockUI({
        message: '<div class="bx bx-revision icon-spin font-medium-2"></div>',
        overlayCSS: {
          backgroundColor: "#fff",
          opacity: 0.8,
          cursor: "wait",
        },
        css: {
          border: 0,
          padding: 0,
          backgroundColor: "transparent",
        },
      });
      this.$apiCall
        .patch(`/v1/properties/${this.house.uid}/status`, {
          status: "approved",
        })
        .then(() => {
          location.reload();
        })
        .catch(error => {
          // $(block_ele).unblock();
          $.unblockUI();
          this.error = "error-message";
          this.errorText = `$t('Ops') ${error.response.data.message}`;
          $("html, body").animate(
            {
              scrollTop: $("body").offset().top,
            },
            500
          );
        })
    },

    getActiveCountries() {
      const countries = localStorage.getItem('activeCountries');
      this.activeCountries = (countries && countries != '') ? countries.split(',') : ["LB", "JO"];
    },

    rejectPropertyModal() {
      this.reject = true;
    },

    goBack() {
      this.reject = false;
      this.errorReject = false;
      this.editingHouse = false;
    },

    rejectProperty() {
      if (this.rejectReason.trim() != "") {
        $.blockUI({
          message: '<div class="bx bx-revision icon-spin font-medium-2"></div>',
          overlayCSS: {
            backgroundColor: "#fff",
            opacity: 0.8,
            cursor: "wait",
          },
          css: {
            border: 0,
            padding: 0,
            backgroundColor: "transparent",
          },
        });
        this.$apiCall
          .patch(`/v1/properties/${this.house.uid}/status`, {
            status: "rejected",
            statusDescription: this.rejectReason,
          })
          .then(() => {
            location.reload();
          })
          .catch(error => {
            // $(block_ele).unblock();
            $.unblockUI();
            this.error = "error-message";
            this.errorText = `$t('Ops') ${error.response.data.message}`;
            $("html, body").animate(
              {
                scrollTop: $("body").offset().top,
              },
              500
            );
          })
      } else {
        this.errorReject = true;
      }
    },

    banProperty() {
      $.blockUI({
        message: '<div class="bx bx-revision icon-spin font-medium-2"></div>',
        overlayCSS: {
          backgroundColor: "#fff",
          opacity: 0.8,
          cursor: "wait",
        },
        css: {
          border: 0,
          padding: 0,
          backgroundColor: "transparent",
        },
      });
      this.$apiCall
        .patch(`/v1/properties/${this.house.uid}/status`, {
          status: "banned",
        })
        .then(() => {
          location.reload();
        })
        .catch(error => {
          // $(block_ele).unblock();
          $.unblockUI();
          this.error = "error-message";
          this.errorText = `$t('Ops') ${error.response.data.message}`;
          $("html, body").animate(
            {
              scrollTop: $("body").offset().top,
            },
            500
          );
        })
    },

    unbanProperty() {
      $.blockUI({
        message: '<div class="bx bx-revision icon-spin font-medium-2"></div>',
        overlayCSS: {
          backgroundColor: "#fff",
          opacity: 0.8,
          cursor: "wait",
        },
        css: {
          border: 0,
          padding: 0,
          backgroundColor: "transparent",
        },
      });
      this.$apiCall
        .patch(`/v1/properties/${this.house.uid}/status`, {
          status: "approved",
        })
        .then(() => {
          location.reload();
        })
        .catch(error => {
          // $(block_ele).unblock();
          $.unblockUI();
          this.error = "error-message";
          this.errorText = `$t('Ops') ${error.response.data.message}`;
          $("html, body").animate(
            {
              scrollTop: $("body").offset().top,
            },
            500
          );
        })
    },

    startEditProperty() {
      this.editingHouse = true;
      this.houseName = this.house.name;
      this.houseCountry = this.house.country
        ? this.house.country.toLowerCase()
        : "lb";
      this.houseCity = this.house.address ? this.house.address.city : "";
      this.houseStreet =
        this.house.address && this.house.address.street
          ? this.house.address.street
          : "";
      this.houseZip =
        this.house.address && this.house.address.zip
          ? this.house.address.zip
          : "";
      this.houseBuildingName =
        this.house.address && this.house.address.buildingName
          ? this.house.address.buildingName
          : "";
      this.houseRegistryNumber =
        this.house.address && this.house.address.registryNumber
          ? this.house.address.registryNumber
          : "";
      this.houseAdditional =
        this.house.address && this.house.address.additional
          ? this.house.address.additional
          : "";
      this.houseDescription = this.house?.address?.description
          ? this.house.address.description
          : "";

      this.houseInventory = [];
      if (this.house.info) {
        this.house.info.inventory.forEach((e) => {
          this.houseInventory.push(e);
        });
      }

      if(this.house.info && this.house.info.additional) {
        const rules = this.house.info.additional.split(',');
        this.houseRules = rules.map(x => x.trim());
      }

      let avDate = "";
      if (this.house.availabilityStart) {
        avDate = this.house.availabilityStart.split("T")[0].split("-");
        avDate = `${avDate[1]}/${avDate[2]}/${avDate[0]}`;
      }
      this.availableDate = avDate;

      this.askingRent = this.house.askingMonthlyRent;
      this.currency = this.house.currency.toUpperCase();
      this.askingDeposit = this.house.askingDeposit;
      this.askingAdvanceMonths = this.house.askingAdvanceMonths;
      this.houseType = this.house.details ? this.house.details.type : "";
      this.houseSize = this.house.details ? this.house.details.size : "";
      this.maxTenants = this.house.details ? this.house.details.maxTenants : "";
      this.floor = this.house.details ? this.house.details.floor : "";
      this.kitchens = this.house.details ? this.house.details.kitchens : "";
      this.sharedKitchen = this.house.details
        ? this.house.details.kitchenShared
        : "";
      this.livingRooms = this.house.details
        ? this.house.details.livingrooms
        : "";
      this.bedrooms = this.house.details ? this.house.details.bedrooms : "";
      this.bathrooms = this.house.details ? this.house.details.bathrooms : "";
      this.sharedBathrooms = this.house.details
        ? this.house.details.bathroomShared
        : "";
      this.selectedFeatures = this.house.details && this.house.details.other ? this.house.details.other : [];

      if (this.house.details && this.house.details.other) {
        this.selectedFeatures.map(x => {
          if(!this.features.includes(x)) {
            this.features.push(x);
          }
        })
      }

      this.conditionDescription = this.house.info
        ? this.house.info.conditionDescription
        : "";
      this.defects = this.house.info ? this.house.info.defects : "";
      this.inventoryStatus =
        this.house.info && this.house.info.inventoryStatus
          ? this.house.info.inventoryStatus
          : "Choose status...";

      if (this.house.info && this.house.info.utilities) {
        this.house.info.utilities.map((x) => {
          switch (x.name) {
            case "Electricity costs": {
              // this.electricityDetails = true;

              if (x.paymentType == "fixed_amount") {
                this.electricityFixed = true;
                this.electricityFixedAmount = x.amount;
                this.electricityFixedAmountRecurrence = x.recurrence;
              } else if (x.paymentType == "shared_percentage") {
                this.electricityShared = true;
                this.electricityPercentage = x.amount;
              }

              break;
            }
            case "Phone bills": {
              // this.phoneDetails = true;

              if (x.paymentType == "fixed_amount") {
                this.phoneFixed = true;
                this.phoneFixedAmount = x.amount;
                this.phoneFixedAmountRecurrence = x.recurrence;
              } else if (x.paymentType == "shared_percentage") {
                this.phoneShared = true;
                this.phonePercentage = x.amount;
              }

              break;
            }
            case "Municipal taxes": {
              // this.municipalDetails = true;

              if (x.paymentType == "fixed_amount") {
                this.municipalFixed = true;
                this.municipalFixedAmount = x.amount;
                this.municipalFixedAmountRecurrence = x.recurrence;
              } else if (x.paymentType == "shared_percentage") {
                this.municipalShared = true;
                this.municipalPercentage = x.amount;
              }

              break;
            }
            case "Ministry of finance taxes": {
              // this.taxesDetails = true;

              if (x.paymentType == "fixed_amount") {
                this.taxesFixed = true;
                this.taxesFixedAmount = x.amount;
                this.taxesFixedAmountRecurrence = x.recurrence;
              } else if (x.paymentType == "shared_percentage") {
                this.taxesShared = true;
                this.taxesPercentage = x.amount;
              }

              break;
            }
            case "Water bills": {
              // this.waterDetails = true;

              if (x.paymentType == "fixed_amount") {
                this.waterFixed = true;
                this.waterFixedAmount = x.amount;
                this.waterFixedAmountRecurrence = x.recurrence;
              } else if (x.paymentType == "shared_percentage") {
                this.waterShared = true;
                this.waterPercentage = x.amount;
              }

              break;
            }
            case "Septic/Seawage bills": {
              // this.septicDetails = true;

              if (x.paymentType == "fixed_amount") {
                this.septicFixed = true;
                this.septicFixedAmount = x.amount;
                this.septicFixedAmountRecurrence = x.recurrence;
              } else if (x.paymentType == "shared_percentage") {
                this.septicShared = true;
                this.septicPercentage = x.amount;
              }

              break;
            }
          }
          this.houseUtilitiesComplete.push(x);
          this.houseUtilitiesSelected.push(x.name);
        });
      }

      if (
        this.inventoryStatus == "furnished" ||
        this.inventoryStatus == "partially"
      ) {
        this.canShowInventory = true;
      }

      this.houseStatus = this.house.status;

      // Check Negotiation Process
      let proposalsURI = [];
      if(this.house.contractProposals){
        this.house.contractProposals.map(proposal => {
          proposalsURI.push(this.$apiCall.get(`/v1/contracts/proposals/${proposal}`));
        })

        Promise.all(proposalsURI)
        .then(response => {
          response.map(res => {
            if(res.data.negotiationStatus){
              this.negotiationInProcess = true;
              $("html, body").animate(
                {
                  scrollTop: $("body").offset().top,
                },
                500
              );
            }
          })
        })
        .catch(error => {
          console.log(error)
        })
      }

      setTimeout(() => {
        //Date Input
        const pD = $("#date-input").pickadate(
          {
            format: "mm/dd/yyyy",
          },
          200
        );
      });
    },

    deleteInventoryItem(index) {
      this.houseInventory.splice(index, 1);
    },

    addInventoryItem(item) {
      this.houseInventory.push(item);
      this.newInventoryItem = "";
    },

    zoomImage(image) {
      $.blockUI({
        message: '<div class="bx bx-revision icon-spin font-medium-2"></div>',
        overlayCSS: {
          backgroundColor: "#fff",
          opacity: 0.8,
          cursor: "wait",
        },
        css: {
          border: 0,
          padding: 0,
          backgroundColor: "transparent",
        },
      });

      this.zoomedImage = image;

      if (this.zoomedImage == image) {
        $.unblockUI();
        $("#zoom-image-modal").modal();
      }
    },

    deleteImage(image) {
      this.house.photos.splice(image, 1);
    },

    addNewUtility(type) {
      switch (type) {
        case "Electricity costs": {
          let utility = {
            name: type,
          };

          $(".electricity-radio").each(function () {
            if ($(this).is(":checked")) {
              utility.paymentType = $(this).val();
            }
          });

          if (!utility.paymentType) {
            utility.paymentType = "tenant";
          }

          if (utility.paymentType == "fixed_amount") {
            utility.amount = Number(this.electricityFixedAmount);
            utility.recurrence = this.electricityFixedAmountRecurrence;
          }

          if (utility.paymentType == "shared_percentage") {
            utility.amount = Number(
              this.electricityPercentage <= 50
                ? this.electricityPercentage
                : 100 - this.electricityPercentage
            );
          }

          this.houseUtilities.push(utility);
          this.electricityDetails = false;
          break;
        }
        case "Phone bills": {
          let utility = {
            name: type,
          };

          $(".phone-radio").each(function () {
            if ($(this).is(":checked")) {
              utility.paymentType = $(this).val();
            }
          });

          if (!utility.paymentType) {
            utility.paymentType = "tenant";
          }

          if (utility.paymentType == "fixed_amount") {
            utility.amount = Number(this.phoneFixedAmount);
            utility.recurrence = this.phoneFixedAmountRecurrence;
          }

          if (utility.paymentType == "shared_percentage") {
            utility.amount = Number(
              this.phonePercentage <= 50
                ? this.phonePercentage
                : 100 - this.phonePercentage
            );
          }

          this.houseUtilities.push(utility);
          this.phoneDetails = false;
          break;
        }
        case "Municipal taxes": {
          let utility = {
            name: type,
          };

          $(".municipal-radio").each(function () {
            if ($(this).is(":checked")) {
              utility.paymentType = $(this).val();
            }
          });

          if (!utility.paymentType) {
            utility.paymentType = "tenant";
          }

          if (utility.paymentType == "fixed_amount") {
            utility.amount = Number(this.municipalFixedAmount);
            utility.recurrence = this.municipalFixedAmountRecurrence;
          }

          if (utility.paymentType == "shared_percentage") {
            utility.amount = Number(
              this.municipalPercentage <= 50
                ? this.municipalPercentage
                : 100 - this.municipalPercentage
            );
          }

          this.houseUtilities.push(utility);
          this.municipalDetails = false;
          break;
        }
        case "Ministry of finance taxes": {
          let utility = {
            name: type,
          };

          $(".taxes-radio").each(function () {
            if ($(this).is(":checked")) {
              utility.paymentType = $(this).val();
            }
          });

          if (!utility.paymentType) {
            utility.paymentType = "tenant";
          }

          if (utility.paymentType == "fixed_amount") {
            utility.amount = Number(this.taxesFixedAmount);
            utility.recurrence = this.taxesFixedAmountRecurrence;
          }

          if (utility.paymentType == "shared_percentage") {
            utility.amount = Number(
              this.taxesPercentage <= 50
                ? this.taxesPercentage
                : 100 - this.taxesPercentage
            );
          }

          this.houseUtilities.push(utility);
          this.taxesDetails = false;
          break;
        }
        case "Water bills": {
          let utility = {
            name: type,
          };

          $(".water-radio").each(function () {
            if ($(this).is(":checked")) {
              utility.paymentType = $(this).val();
            }
          });

          if (!utility.paymentType) {
            utility.paymentType = "tenant";
          }

          if (utility.paymentType == "fixed_amount") {
            utility.amount = Number(this.waterFixedAmount);
            utility.recurrence = this.waterFixedAmountRecurrence;
          }

          if (utility.paymentType == "shared_percentage") {
            utility.amount = Number(
              this.waterPercentage <= 50
                ? this.waterPercentage
                : 100 - this.waterPercentage
            );
          }

          this.houseUtilities.push(utility);
          this.waterDetails = false;
          break;
        }
        case "Septic/Seawage bills": {
          let utility = {
            name: type,
          };

          $(".septic-radio").each(function () {
            if ($(this).is(":checked")) {
              utility.paymentType = $(this).val();
            }
          });

          if (!utility.paymentType) {
            utility.paymentType = "tenant";
          }

          if (utility.paymentType == "fixed_amount") {
            utility.amount = Number(this.septicFixedAmount);
            utility.recurrence = this.septicFixedAmountRecurrence;
          }

          if (utility.paymentType == "shared_percentage") {
            utility.amount = Number(
              this.septicPercentage <= 50
                ? this.septicPercentage
                : 100 - this.septicPercentage
            );
          }

          this.houseUtilities.push(utility);
          this.septicDetails = false;
          break;
        }
      }

      console.log("Utilities", this.houseUtilities);
    },

    handleSharedRadio(evt, type, value) {
      if (evt.target.checked) {
        switch (value) {
          case "Electricity costs": {
            this.electricityShared = type == "fixed_percentage" ? true : false;
            this.electricityFixed = type == "tenant_fixed" ? {} : false;
            break;
          }
          case "Phone bills": {
            this.phoneShared = type == "fixed_percentage" ? true : false;
            this.phoneFixed = type == "tenant_fixed" ? {} : false;
            break;
          }
          case "Municipal taxes": {
            this.municipalShared = type == "fixed_percentage" ? true : false;
            this.municipalFixed = type == "tenant_fixed" ? {} : false;
            break;
          }
          case "Ministry of finance taxes": {
            this.taxesShared = type == "fixed_percentage" ? true : false;
            this.taxesFixed = type == "tenant_fixed" ? {} : false;
            break;
          }
          case "Water bills": {
            this.waterShared = type == "fixed_percentage" ? true : false;
            this.waterFixed = type == "tenant_fixed" ? {} : false;
            break;
          }
          case "Septic/Seawage bills": {
            this.septicShared = type == "fixed_percentage" ? true : false;
            this.septicFixed = type == "tenant_fixed" ? {} : false;
            break;
          }
        }
      }
    },

    handleServiceCheckbox(evt, value) {
      if (evt.target.checked) {
        switch (value) {
          case "Electricity costs": {
            this.electricityDetails = true;
            break;
          }
          case "Phone bills": {
            this.phoneDetails = true;
            break;
          }
          case "Municipal taxes": {
            this.municipalDetails = true;
            break;
          }
          case "Ministry of finance taxes": {
            this.taxesDetails = true;
            break;
          }
          case "Water bills": {
            this.waterDetails = true;
            break;
          }
          case "Septic/Seawage bills": {
            this.septicDetails = true;
            break;
          }
        }
      } else {
        this.houseUtilities = this.houseUtilities.filter((element) => {
          return element.name != value;
        });

        switch (value) {
          case "Electricity costs": {
            this.electricityDetails = false;
            this.electricityShared = false;
            break;
          }
          case "Phone bills": {
            this.phoneDetails = false;
            this.phoneShared = false;
            break;
          }
          case "Municipal taxes": {
            this.municipalDetails = false;
            this.municipalShared = false;
            break;
          }
          case "Ministry of finance taxes": {
            this.taxesDetails = false;
            this.taxesShared = false;
            break;
          }
          case "Water bills": {
            this.waterDetails = false;
            this.waterShared = false;
            break;
          }
          case "Septic/Seawage bills": {
            this.septicDetails = false;
            this.septicShared = false;
            break;
          }
        }
      }
    },

    comparer(otherArray) {
      return function (current) {
        return (
          otherArray.filter(function (other) {
            return (
              other.name == current.name
            );
          }).length == 0
        );
      };
    },
    getUtilities(){
      let utilities = null;
      if (this.houseUtilities.length == 0) {
        if(this.house.info){
          utilities = this.house.info.utilities;
        } else{
          utilities = [];
        }
      } else if(this.house.info?.utilities){
        let filtered = this.house.info.utilities.filter(this.comparer(this.houseUtilities));
        utilities = this.houseUtilities.concat(filtered);
      } else{
        utilities = this.houseUtilities;
      }
      return utilities
    },
    editHouse() {
      let self = this;

      this.error = "";
      this.errorText = "";

      let address = {
        country: this.houseCountry,
        city: this.houseCity,
        zip: this.houseZip,
        street: this.houseStreet,
        additional: this.houseAdditional,
        buildingName: this.houseBuildingName,
        registryNumber: this.houseRegistryNumber,
        description: this.houseDescription,
      };
      let details = {
        type: this.houseType,
        size: parseInt(this.houseSize),
        maxTenants: parseInt(this.maxTenants),
        floor: parseInt(this.floor),
        livingrooms: parseInt(this.livingRooms),
        bedrooms: parseInt(this.bedrooms),
        kitchens: parseInt(this.kitchens),
        kitchenShared: !!$("#shared-kitchen").is(":checked") ,
        bathrooms: parseInt(this.bathrooms),
        bathroomShared: !!$("#shared-bathroom").is(":checked") ,
        other: this.selectedFeatures
      };
      let photos = [];

      let utilities = this.getUtilities();
      console.log("INFO", this.house.info)


      //Latest utilities check
      let activeUtilities = [];
      $(".service-checkbox").each(function(){
        if($(this).is(":checked")){
          activeUtilities.push($(this).val())
        }
      })

      console.log(activeUtilities)

      if(utilities){
        utilities = utilities.filter(x => {
          return activeUtilities.includes(x.name)
        })
      }

      // this.houseUtilities.length == 0
      //   ? this.house.info.utilities
      //   : this.houseUtilities;

      let info = {
        defects: this.defects,
        conditionDescription: this.conditionDescription,
        inventoryStatus:
          this.inventoryStatus != "Choose status..."
            ? this.inventoryStatus
            : "",
        inventory:
          this.inventoryStatus == "furnished" ||
          this.inventoryStatus == "partially"
            ? this.houseInventory
            : [],
        utilities: utilities,
        additional: this.houseRules.join(', ')
      };

      if (this.house.photos) {
        photos = this.house.photos;
      }

      let available = $("#date-input").val().split("/");
      available = `${available[2]}-${available[0]}-${available[1]}T00:00Z`;

      console.log(info)

      $.blockUI({
        message: '<div class="bx bx-revision icon-spin font-medium-2"></div>',
        overlayCSS: {
          backgroundColor: "#fff",
          opacity: 0.8,
          cursor: "wait",
        },
        css: {
          border: 0,
          padding: 0,
          backgroundColor: "transparent",
        },
      });
      let changeStatus = false;
      this.$apiCall
        .patch(`/v1/properties/${this.house.uid}`, {
          name: this.houseName,
          availabilityStart: available,
          askingMonthlyRent: parseFloat(this.askingRent),
          askingDeposit: parseFloat(this.askingDeposit),
          askingAdvanceMonths: parseInt(this.askingAdvanceMonths),
          currency: this.currency.toLowerCase(),
          address: address,
          info: info,
          details: details,
          photos: photos
        })
        .then((response) => {

          if(this.house.status == 'preapproved'){
            changeStatus = true;
            this.$apiCall.patch(`/v1/properties/${this.house.uid}/status`, {
              status: 'needs_approval_by_landlord'
            })
            .then(() => {
              $.unblockUI();
              location.reload();
            })
            .catch(error => {
              $.unblockUI();
              this.error = "error-message";
              this.errorText = `$t('Ops') ${error.response.data.message}`;
              $("html, body").animate(
                {
                  scrollTop: $("body").offset().top,
                },
                500
              );
            })
          }

          if(this.house.status == 'draft_by_admin' && this.houseStatus == 'needs_approval_by_landlord'){
            changeStatus = true;
            this.$apiCall.patch(`/v1/properties/${this.house.uid}/status`, {
              status: 'needs_approval_by_landlord'
            })
            .then(() => {
              $.unblockUI();
              location.reload();
            })
            .catch(error => {
              $.unblockUI();
              this.error = "error-message";
              this.errorText = `$t('Ops') ${error.response.data.message}`;
              $("html, body").animate(
                {
                  scrollTop: $("body").offset().top,
                },
                500
              );
            })
          }

          if(!changeStatus){
            $.unblockUI();
            location.reload();
          }
        })
        .catch(error => {
          $.unblockUI();
          this.error = "error-message";
          this.errorText = `$t('Ops') ${error.response.data.message}`;
          $("html, body").animate(
            {
              scrollTop: $("body").offset().top,
            },
            500
          );
        })
    },

    createProposal(uuid) {
      this.$router.push({
        path: "/contracts/proposals/create",
        query: { house: uuid },
      });
    },
  },

  mounted() {
    this.getToken();
    this.getActiveCountries();
  },
};
</script>

<style scoped>

.hidden{
  display: none;
}

.house-image img {
  box-shadow: 4px 4px 4px 0px rgba(0, 0, 0, 0.2);
}

.house-image {
  position: relative;
  cursor: pointer;
}

.overlay {
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  top: 0;
  left: 0;
  border-radius: 0.267rem !important;
  display: none;
}

.overlay i {
  font-size: 3em;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.house-image:hover > .overlay {
  display: block;
}

.inventory-item {
  color: #475f7b;
  font-weight: 500 !important;
  font-size: 1.1rem;
  margin-bottom: 10px;
}
</style>
